<template lang='pug'>
    div.portal-container.container-fluid.px-0.scrollbar.poratl_height_100vh()
        MenuBarPortal(@getQuestionDetail='getThread' :member='member' :generating="generating" :companylogo_url="companylogo_url" :show_private_knowledge="show_private_knowledge" ref='menuBarPortal' @deleteThreadAgentItem='deleteThreadAgentItem' style='z-index: 999;')
        licenseWarningBanner(v-if='is_new_insert')
        div.container-fluid.pt-0(v-if='is_new_insert')
            v-row.justify-center.portal-page-mt-height(no-gutters='' )
                v-col(cols='12')
                    .conversation 
                        v-card.text-block.ma-0.pa-0.conversation_title(flat='' max-height='38' style='background: var(--portal_background);') 
                            span {{ $t('MAIN_PORTAL_VIEW.INTRO') }}
                        v-container.d-flex.justify-center.align-center(style=' padding: 36px 24px;')
                            ThreadInputTab(ref="threadInputRef" :knowledge-list="knowledgeList" :knowledge-list-private="KnowledgeListPrivate"  :selected-knowledge-libs.sync="selectedKnowledgeLibs" :all-knowledge-color="allKnowledgeColor" :agent_to_userInput="agent_to_userInput"
                            :folderTreeOptions="folderTreeOptions"
                             @sendmessage='createThread' @clearAgent="clearAgent" @showErrorDialog="showErrorDialog")
                v-col.flex-column(v-if='loading' cols='12' md='8')
                    portalGenerateAnswerSkeleton(mode='agents')
                    portalGenerateAnswerSkeleton(mode='agents')
                v-col.d-flex.flex-column(v-else cols='12')
                    v-row.ml-auto.pr-8(v-if="$vuetify.breakpoint.smAndDown")
                        v-btn.px-2.my-auto.ml-4(outlined dense height="30" @click="addAgent") 
                            v-icon(color="#444") mdi-plus
                            span(style='color: #444 !important;') {{ $t('AGENT.ADD_SIMPLE_AGENT') }}
                    v-row.agent-filter-box.mx-auto
                        v-chip-group(show-arrows)
                            v-chip.mr-3(v-for="agentStylefilter in agentfilterStyleList" :key="agentStylefilter.key" text-color="#444" :class="agentStylefilter.active?'agentfilter-active':'agentfilter-default'" :color="agentStylefilter.active?'#CCC': '#F4F4F4'" flat style='font-size:15px;' @click="toggleAgentChips(agentStylefilter)") {{agentStylefilter.name}}
                            v-divider.mr-2(vertical)
                            v-chip.mr-3(v-for="agentPolicyfilter in agentfilterPolicyList" :key="agentPolicyfilter.key" text-color="#444" :class="agentPolicyfilter.active?'agentfilter-active':'agentfilter-default'" :color="agentPolicyfilter.active?'#CCC': '#F4F4F4'" flat style='font-size:15px;' @click="toggleAgentChips(agentPolicyfilter)") {{agentPolicyfilter.name}}
                            v-btn.px-2.my-auto.ml-4(outlined dense height="30" @click="addAgent" v-if="$vuetify.breakpoint.smAndUp") 
                                v-icon(color="#444") mdi-plus
                                span(style='color: #444 !important;') {{ $t('AGENT.ADD_SIMPLE_AGENT') }}
                    v-row.pt-2.px-2.portal-agent-landing.scrollbar-portal.mx-auto()
                        v-col.d-flex.justify-center(cols='12' md='4' sm='6' class="mt-1" v-for="(agentCardData, index) in AgentsList" :key='agentCardData.id' id="agent_list").pl-sm-0.pt-0
                            agentCard(:agentCardData="agentCardData" :allKnowledgeColor='allKnowledgeColor' :user_mode="true" :allow_click="true" 
                            @openSelectDrawer="open_select_drawer" @emitEditAgentCard='onEmitEditAgentCardDetail' @emitDeleteAgent='onEmitDeleteAgentDetail' @applyAgent="applyAgent")
        div.container-fluid(v-else-if='is_user_setting')
            v-row#page-head.d-flex.align-center.justify-md-space-between.pt-15.pt-lg-0
              v-col.d-flex.align-center.px-0.px-md-4.pt-6.pb-3(cols='12' md='12')
                span.usersettingtitle   {{$t('SETTING.PERSONALSETTING')}}
            #page-inner.scroll-x.pb-0.height_100vh
              .upload_page_height.scrollbar.px-3.py-sm-2.py-xs-1()
                  v-container().px-0.px-md-3
                      UserSetting(@logoutSuccess='logoutSuccess')
        div(v-else-if='is_knowledges')
            template
                Knowledges_portal(@getKnowledgeDetail='getKnowledge' :show_private_knowledge_add_btn="show_private_knowledge_add_btn")
        div(v-else-if='is_knowledge')
            template
                knowledge(@breadcrumbs-click="toKnowledges" :is_private="true" :target_id="knowledge_id")
        div(v-else-if='is_document_agent')
            template
                DocumentAgent(:doc_agent_data="doc_agent_data" :doc_agent_id="doc_agent_id" :user_id="userID" @emitDocumentDetail="onEmitDocumentDetail")
        #Portal.portaldetail-main-page.upportal-color.pb-0.position-relative(v-else)
            licenseWarningBanner
            v-row.d-flex.flex-nowrap.align-center.justify-md-space-between.py-5.pb-3(v-if="$vuetify.breakpoint.lgAndUp" style='border-bottom: 1px solid #E8E8E8; position: sticky; top: 0; right: 0; width: 100%; background: var(--portal_background);  z-index: 20;')
                v-col.d-flex.align-center.p-0.ml-5(cols='10')
                    v-avatar(color='aliceBlue' style='height: 30px;min-width: 30px;width: 30px;')
                        span(v-if="member.pic == null || member.pic == ''") {{ member.nickname}}
                        img(v-else :src='member.pic' height="80" :alt='member.name')
                    .pl-2.pr-3.user_icon
                        span.name.ellipsis(style='color: #666') {{member.name}}
                //- v-col.ml-3.py-0(cols='1')
                //-     v-btn(v-hide-element='false' :href='"/upgpt/Knowledges/"' width='100%' max-width='105'  height='35' color='#14C6DE' :ripple='false'  depressed  dark style='border-radius:4px')
                //-         v-icon.pr-1.py-2(size='16' color='white') mdi-share-variant
                //-         span.font-weight-bold {{$t("PORTAL.SHARE")}}
            portalLoadingSkeleton(v-if='loading')
            div.container-fluid.p-0(v-else)
                v-row.questionItem(:style="generating ? 'margin-bottom: 0%;': ''"  v-for="(detail,index) in portalDetails" :key="detail.question_id" :id="'question-' + index" :data-target="'question-' + index" :ref="'questionItem-' + index")
                    v-col.UpPortal-height.pl-lg-6(cols='12' lg='8')
                        div.mb-1.primary-input.font-weight-medium(:class="{'can-select-text': !disableCopy}") {{detail.question_title}}
                        div.portal-time.mb-4(v-if='detail.question_on') {{ getPortalFormatTime(detail.question_on) }}
                        v-tabs(v-model='detail.tabs_current' background-color="transparent" :slider-color="answer_bottom_border"  height="40" id='portaltabs')
                            v-tab(v-for='item in detail.tabs' :key='item.key' :href='`#tab-${item.id}`' exact-active-class="portal-active-tab"  style='display:flex; justify-content:center !important;' )
                                span.tabs-title {{ item.name }}
                            v-tab-item(key='Answer' value='tab-1' :transition='false' :reverse-transition='false' style='min-height:0px;' )
                                v-row.mt-lg-5.mt-2
                                    v-col.d-flex.align-center.pa-0(cols='auto')
                                        v-img(src="@/assets/images/reference-icon.svg" max-width="22px"  height="22px")
                                        span.text-title.pl-2 {{$t("PORTAL.REFERENCE")}}
                                    v-spacer
                                    v-col.d-flex.pa-0(cols='auto')
                                        v-menu(v-if="detail.ui_diaplay_source_type != 'agent'" z-index="22" persistent)
                                            template(v-slot:activator="{ on }")
                                                v-btn.portal-btn-black.pr-0.pl-0(v-on="on" @click="getQuestionKnowledge(detail.question_id)" text elevation='0' :disabled="generating || detail.ui_diaplay_source_type == 'agent'" color="transparent")
                                                    v-img.pr-2(contain src="@/assets/images/knowledge-lib-icon.svg" max-width="22px" height="22px")
                                                    v-icon.pr-1.ml-1(size='12' color='#444' v-if="detail.ui_diaplay_source_type != 'agent'") fa-chevron-down
                                            KnowledgeList(:knowledge-list="questionKnowledgeList" :knowledge-list-private="KnowledgeListPrivate" :all-knowledge-color="allKnowledgeColor" :selected-knowledge-libs="portalDetails[index].knowledges" :is_upsert="true" :generating="generating" :canSearchWeb="detail.use_web_search" :folderTreeOptions="folderTreeOptions" :canUseKB="detail.use_knowledge_lib" @returnselectedKnowledge="data => getselectedKnowledgeList(data, index)" @upsertQuestion="data => triggerUpsert(data, detail)" @usewebsetting="data => changeWebSearchSetting(data, detail)" @useknowledgesetting="data => changeUseKnowledgeSetting(data, detail)")
                                        v-col.d-none.d-sm-flex.align-center.pa-0(v-if="detail.use_knowledge_lib")
                                            v-avatar.ml-1(v-for='item in detail.knowledges.slice(0,detail.knowledges.length==10? 10:knowledgeListShowAll)' :key="item.id" :title='item.name'  :color='getColorFromKnowledgeName(item.name)' size='20' rounded="100")
                                                span(style='font-size:14px; padding-bottom:2px;') {{item.name.slice(0,1)}}
                                            v-avatar.ml-1(v-if='detail.knowledges.length > knowledgeDefaultLength+1' color='#a2a2a2' size='20' rounded="100" @click='showAllKnowledge(detail.knowledges)')
                                                span(style='font-size:14px; padding-bottom:2px;') {{ knowledgeListShowAll > knowledgeDefaultLength ? "--" : "+" + String(detail.knowledges.length-knowledgeDefaultLength)}}

                                v-row.mb-3(:class='')
                                    template
                                        v-col.px-1.pt-1.pb-1(cols='6' sm='3' v-for="(reference) in detail.references.slice(0,3)" :key="reference.context_id")
                                            v-hover
                                                template(v-slot:default="{ hover }")
                                                    v-card.reference-card.mark-card.px-2.d-flex.flex-column.justify-space-between(:class="hover ? 'reference-card-hover' : ''" :elevation="hover?3:''" flat  :ripple="false" @click="openDrawer(detail.question_id, reference.context_id, detail.references, detail)")
                                                        v-card-title.flex-nowrap.pa-0.d-flex.align-center.ellipsis
                                                            v-avatar.mark.ml-1( size='16' tile)
                                                                span(style='font-size:10px; color:#666; padding-bottom:1px;') {{reference.context_id}}
                                                            span.ml-2.textx-subtitle-2.font-weight-bold(:title='reference.title?reference.title:reference.filename') {{reference.title?reference.title:reference.filename}}
                                                        v-card-text.pt-0.pb-0.pl-7(v-if="reference.display_type=='IMAGE'")
                                                            img.mb-1.source_image(v-if="reference.doc_image_urls && reference.doc_image_urls[0] && reference.doc_image_urls[0].doc_image_url" :src='reference.doc_image_urls[0].doc_image_url' width='45' height='auto' @error="handleImageError" :draggable="!disableCopy" style="aspect-ratio:16/9; object-fit:cover; border-radius:3px;" alt='reference image',)
                                                            img.mb-1.source_image(v-else :src='errorbackImage' width='45' height='auto' :draggable="!disableCopy" style="aspect-ratio:16/9; object-fit:cover; border-radius:3px;" alt='Not image avaiable')
                                                        div
                                                            v-card-text.ellipsis.pl-0.pb-1(:class="reference.display_type=='IMAGE'?'pt-0':''")
                                                                v-avatar.ml-1(v-if="reference.chunk_id == 'bing_search_result'" color='white' size='17' rounded="100")
                                                                    //- v-icon(size='14' color='#444') mdi-cloud-search-outline
                                                                    img(:src="getWebIcon(reference.cloud_url)" max-width="17px" @error="onWebIconImgError")
                                                                v-avatar.ml-1(v-else :color="getColorFromKnowledgeName(reference.knowledge_lib_name)" size='17' rounded="100"  :title="reference.knowledge_lib_name") 
                                                                    span(style='font-size:10px; padding-bottom:2px;' ) {{reference.knowledge_lib_name.slice(0,1)}}
                                                                span.pl-2.file(:title="reference.filename") {{reference.filename}}
                                                            v-card-text.ellipsis.pa-0.pl-0.pb-1(v-if="reference.chunk_id == 'bing_search_result'" style="margin-top: -10px;")
                                                                span.pl-8(:title="reference.cloud_url" style='color:#666;') {{reference.cloud_url}}
                                            span.pt-1.d-flex(:class="{'can-select-text': !disableCopy}")
                                                span.d-flex(v-if='reference.page_num.length>0' style="font-weight:500; font-size:11px;") 
                                                    v-img(src="@/assets/images/book-mark.svg" max-width="20px" style="display: inline-block; margin-top: 2px;")
                                                    span Page {{reference.page_num[0]}} 
                                                    span(v-if="reference.page_num[0] !== reference.page_num[reference.page_num.length-1]") - {{reference.page_num[reference.page_num.length-1]}}           
                                                v-chip.ml-auto(flat style='font-size:10px;') {{reference.score_percentage}}%
                                        v-col.pl-1.pr-2.pl-0.pt-1.pb-4(cols='6' sm='3' v-if='detail.references.length>3')
                                            v-hover
                                                template(v-slot:default="{ hover }")
                                                    v-card.reference-card.mark-card.px-3(:class="hover ? 'reference-card-hover' : ''" :elevation="hover?3:''" flat @click="openDrawer(detail.question_id, 'ALL', detail.references, detail)")
                                                        v-card-text.d-flex.flex-nowrap.pa-0.mt-1()
                                                            v-icon.mr-1(size='16') mdi-eye
                                                            span.mr-1(style='font-size:0.7rem')  View all references
                                                            v-icon(size='16') mdi-trending-neutral
                                                        v-card-text.pt-0.px-1
                                                            v-avatar.mark.ml-1(v-for=" (avatar,i) in detail.references.slice(3,15)" :key="'avatar-'+i"  size='17' tile)
                                                                span.pb-1(v-if="(i+4) == 15") +
                                                                span(v-else style='font-size:10px; padding-bottom:1px;') {{i+4}}
                                        //- div(slot="viewport" class="flicking-pagination")
                                    v-col.d-flex.justify-center.px-auto.py-0(cols='12' v-if='detail.references.length==0 && generating && detail.isSkeleton')
                                        portalGenerateAnswerSkeleton(mode='reference')
                                    v-col.d-flex.justify-center.px-auto.py-0(cols='12' v-else-if='detail.references.length==0 && (!detail.generating) && (!detail.isSkeleton)')
                                        v-alert.mt-6.mb-4(dense text color="#FB8C00" icon="mdi-alert-outline") {{$t("PORTAL.NO_REFERENCE_MESSAGE")}}
                                v-row.d-flex.align-center.my-auto.mt-lg-5.mt-2()
                                    v-img(v-if='generating' src="@/assets/images/ans-book.gif" max-width="25px" width="20px" height="20px")
                                    v-img(v-else src="@/assets/images/ans-book.svg" max-width="25px" width="20px" height="20px")
                                    span.text-title.pl-2 {{$t("PORTAL.ANSWER")}}
                                v-row(v-if='detail.reasoning_thinking')
                                    div.reasoning-thinking-position
                                        p.reasoning-header(v-if='detail.reasoning_thinking !== ""') {{$t("PORTAL.THINKING_GENERATE")}}
                                    vue-markdown.reasoning-text(:class="{'can-select-text': !disableCopy}" :source='String(getAnsSupStr(detail.reasoning_thinking))' breaks)
                                v-row(v-if='detail.function_calling !== ""')
                                    p.function-calling-text  {{detail.function_calling}}
                                v-row.answer-line-height(:ref="'questionItem-related-' + index")
                                    portalGenerateAnswerSkeleton(v-if='detail.isSkeleton' mode='generate_answer' :show="showGenerateAnsSkeleton")
                                    div.answer(:class="{'can-select-text': !disableCopy}" v-if="!detail.isSkeleton && !detail.generating && !detail.content && detail.ui_diaplay_source_type != 'agent'")
                                        | {{ $t('PORTAL.ANSWER_INTERRUPTED') }}
                                    vue-markdown.answer(:class="{'can-select-text': !disableCopy}" :source='String(getAnsSupStr(detail.content))' :data-question-id="detail.question_id"  breaks v-else-if=" detail.references.length>0 || (!hide_ans_without_ref || detail.generating || detail.isSkeleton)")
                                    div.answer(:class="{'can-select-text': !disableCopy}" v-else-if="detail.references.length==0" )
                                        | {{ $t('PORTAL.NO_RELATED_ANSWER') }}
                                v-divider
                                v-row.my-0
                                    v-spacer
                                    v-col.d-flex.pt-1.pb-0.pr-0.pl-0(cols='auto')
                                        span.portal-time.d-flex.align-center.mr-2(v-if="!detail.isSkeleton && detail.answer_on") {{ getPortalFormatTime(detail.answer_on) }}
                                        v-tooltip(bottom v-if="!detail.isSkeleton")
                                            template(v-slot:activator='{ on, attrs }')
                                                v-btn.mr-1(icon v-bind='attrs' v-on='on' @click="toggleThumbUp(detail)")
                                                    v-img(v-if="detail.thumb_up" src="@/assets/images/good-active.svg" max-width="21px" width="21px")
                                                    v-img(v-else src="@/assets/images/good-white.svg" max-width="21px" width="21px")
                                            span {{$t("PORTAL.HELPFUL")}}
                                        v-tooltip(bottom  v-if="!detail.isSkeleton" )
                                            template(v-slot:activator='{ on, attrs }')
                                                v-btn.mr-1(icon v-bind='attrs' v-on='on' @click="toggleThumbDown(detail)")    
                                                    v-img(v-if="detail.thumb_down" src="@/assets/images/bad-active.svg" max-width="21px" width="21px")
                                                    v-img(v-else src="@/assets/images/bad-white.svg" max-width="21px" width="21px")
                                            span {{$t("PORTAL.UNHELPFUL")}}    
                                        //- v-btn.ml-1(icon)
                                        //-     v-icon.pr-2.py-2(size='22') mdi-share-variant
                                        v-tooltip(bottom v-if="(detail.references.length>0 || !hide_ans_without_ref) && (!detail.isSkeleton ) && !disableCopy")
                                            template(v-slot:activator='{ on, attrs }')
                                                v-btn.ml-1(icon v-bind='attrs' v-on='on' @click='copyAnswer(detail.content)')
                                                    v-img(v-if='!copied' src="@/assets/images/copy.svg" max-width="21px" width="21px")
                                                    v-img(v-else src="@/assets/images/copied.svg" max-width="21px" width="21px")
                                            span {{$t("PORTAL.COPY")}}   
                                        v-tooltip(bottom v-if="detail.ui_diaplay_source_type != 'agent' &&  !detail.isSkeleton ")
                                            template(v-slot:activator='{ on, attrs }')
                                                v-btn.ml-1(icon v-bind='attrs' v-on='on' :disabled='generating', @click="upsertQuestionData(detail)")    
                                                    v-img(src="@/assets/images/ai-write.svg" max-width="21px" width="21px")
                                            span {{$t("PORTAL.REWRITE")}}   
                                div.mb-4(v-if="(detail.ui_diaplay_source_type == 'answer' && detail.related.length != 0 && detail.related.length != '') && (detail.references.length>0 || (!hide_ans_without_ref))")
                                    v-row.d-flex.align-center.mt-lg-7.mt-4(v-if="detail.ui_diaplay_source_type == 'answer'")
                                        v-img(src="@/assets/images/related-ans-icon.svg" max-width="22px"  height="22px")
                                        span.text-title.pl-2 {{$t("PORTAL.Related")}}
                                    template(v-if='detail.isSkeleton')
                                        v-row.flex-nowrap
                                            portalGenerateAnswerSkeleton(mode='related_questions')
                                    template(v-else)
                                        v-row.flex-nowrap.relative-question( cols='3' v-for="(relatedQuestion, i) in detail.related" :key="'related-questions-'+i" style='border-bottom: 1px solid #E8E8E8; cursor :pointer;' :ref="'relatedQuestion'+i" @click='!generating && upsertQuestionData(detail,i)' v-if="relatedQuestion != ''")
                                            v-col.d-flex.align-center.pl-2.related-hover(cols='11') {{relatedQuestion}}
                                            v-col.d-flex.align-center.justify-center.py-0.px-0(cols='1')
                                                v-icon.pa-0(size='25' :color="new_question_btn") mdi-plus
                            v-tab-item.step-panel(key='step' value='tab-2' :transition='false' :reverse-transition='false' style='min-height:250px;' )
                                v-expansion-panels.pl-7.pr-5.pt-5(v-model="detail.step_current" multiple tile accordion bg-color="transparent")
                                    v-expansion-panel(v-for="(step_item, i) in detail.step_flow" :key="step_item.step_type+'-'+i"  style="position: relative; border-left: 2px solid #ccc; border-bottom: 1px solid #E8E8E8")
                                        v-avatar(color='#14C6DE' size='18' style="position: absolute; left:-10px; top: -5px;")
                                            //- span(v-if="item.step_current.includes(i)")
                                            span.d-flex()
                                                v-icon.align-center.justify-center(color="white", size="15") mdi-check
                                        v-expansion-panel-header.pt-2(style="font-weight: 500; color: #444;") {{ $t(getLangKeyToName('AGENT.STEP_', step_item.step_type)) }}
                                        v-expansion-panel-content.answer-line-height(style="color: #444;")
                                            //- Step 的 Skeleton
                                            template(v-if="step_item.step_memory == ''")
                                                portalGenerateAnswerSkeleton(mode='step_response_answer')
                                            template(v-if="typeof step_item.step_memory == 'string'")
                                                vue-markdown.answer(:source='String(getAnsSupStr(step_item.step_memory))')
                                            //- 使用者輸入STEP
                                            template(v-if="typeof step_item.step_memory == 'object' && step_item.step_type == 'user_input'")
                                                div(v-for="(value, key) in step_item.step_memory" :key="key")
                                                    div {{ value }}
                                                //- template(v-if="step_item.step_memory.question")
                                                //-     span {{step_item.step_memory.question}}
                                                //- template(v-if="step_item.step_memory.upload_image && step_item.step_memory.upload_image != ''")
                                                //-     div {{step_item.step_memory.upload_image}}
                                                //- template(v-if="step_item.step_memory.customer")
                                                //-     div {{step_item.step_memory.customer}}
                                                //- template(v-if="step_item.step_memory.solution")
                                                //-     div {{step_item.step_memory.solution}}
                                                //- template(v-if="step_item.step_memory.products")
                                                //-     div {{step_item.step_memory.products}}
                                                //- template(v-if="step_item.step_memory.translate_to")
                                                //-     div {{step_item.step_memory.translate_to}}
                                            template.d-flex(v-if="Array.isArray(step_item.step_memory) && step_item.step_memory.length > 0")
                                                template(v-if="step_item.step_memory.some(ref => ref.query)")
                                                    div(v-for="(ref, idx) in step_item.step_memory" :key="idx")
                                                        div(style="margin-bottom: 4px;") {{$t("AGENT.FOLLOW_UP_QUESTION")}}: {{ ref.query }}
                                                        //- div {{$t("AGENT.CONTENT")}}:{{formatContent(ref.content)}}
                                                template(v-else)
                                                    div.d-flex
                                                        div.mr-2(v-for="(resource,i) in step_item.step_memory" :key="resource.filename+'-'+i" color="#F4F4F4" :ripple='false' style="border:1px solid #444; border-radius: 50px; gap: 4px;")
                                                            div.pl-1.mr-2(style="display: flex; align-items: center; gap: 4px;")
                                                                v-avatar.pl-2(tile size="25")
                                                                    v-img(:src="getFileIcon(resource.filename)" max-width="18px" width="18px" height="18px") 
                                                                span.ellipsis-single(:title="resource.filename" style="color: #444;") {{ resource.filename }}
                                                    div(style="margin-top:16px")
                                                        template(v-if='detail.isSkeleton && step_item.step_type == "read_document"')
                                                            v-row.flex-nowrap
                                                                portalGenerateAnswerSkeleton(mode='step_response_answer')
                    //- Related Images
                    v-col.pt-10(cols='4' v-if="$vuetify.breakpoint.lgAndUp")
                        v-row.d-flex.align-center.my-auto
                            v-img(src="@/assets/images/related-images-icon.svg" max-width="22px" width="22px" )
                            span.text-title.pl-2 {{$t("PORTAL.RelatedImages")}}
                        v-row(v-if="detail.related_image.length>0 && !detail.isSkeleton")
                            v-col.pl-0.pr-2.pt-0.pb-2(v-for="(img,index) in filteredImages(detail)" :key="index" :cols="index==0 ? 12:6")
                                v-card.related-img-card(elevation='0')
                                    img(:src="img.doc_image_url" @click='openWindowDisplayImage(img)' @error="handleImageError" :draggable="!disableCopy" style="width:100%; aspect-ratio:16/9; object-fit:cover; cursor:pointer;")
                                    v-card-text.ellipsis.related-img-overlay
                                        v-chip.related-img-label.mr-1(label) {{img.context_id}}
                                        span.text-white Page {{img.page_num}},
                                        span.pl-1.text-white(v-if="img.image_num!=''") Image {{img.image_num==''?0:img.image_num}}
                        v-row.related_images-skeleton(v-else-if="detail.related_image.length==0 && generating && detail.isSkeleton")
                            portalGenerateAnswerSkeleton(mode='related_images')
                        v-row.mt-4.justify-center(v-else-if="detail.related_image.length==0 && !detail.isSkeleton")
                            p.mt-4.no-reference-related-text No related image
                        v-row.mt-1()
                            v-col.py-0.d-flex
                                v-btn.portal-btn-black.px-0(v-if='detail.related_image.length>3' @click='viewLessRelatedImage()' text elevation='0' color="transparent")
                                    v-img(src="@/assets/images/related-img-btn.svg" max-width="20px" width="20px")
                                    span.ml-1(v-if="showAllImage") {{$t("PORTAL.ViewMore")}}
                                        v-icon.ml-1(size='12' color='#444') fa-chevron-down
                                    span.ml-1(v-else) {{$t("PORTAL.ViewLess")}} 
                                        v-icon.ml-1(size='12') fa-chevron-up
            //- 最後一個問題與最底下的距離，不會被輸入框擋住即可
            div.pa-0.m-0(style='height: 50px; min-width: 50px; width: 50px;')
            //- In mobile show tags
            div.container-fluid.mobileTags.hidden-lg-and-up
                v-row.justify-space-around
                    v-col.pl-2()
                        v-chip-group(show-arrows)
                            v-chip.v-chip-size-mobile.px-3(v-for="tag in visibleTags" :key="tag.id" outlined text-color="#444" :class="{'selected-chip': tag.type == selectedMobileTagType}" @click="clickMobileTag(tag.type)" style="border-color:#CCC;")
                                v-avatar(tile)
                                    v-img(:src="tag.image" max-width="18px" width="18px" height="18px") 
                                span {{tag.fullName}}  
            detailThreadInput.detailThreadInput(:knowledge-list="knowledgeList" :knowledge-list-private="KnowledgeListPrivate" :selected-knowledge-libs="selectedKnowledgeLibs" :streamingId="streamingId" :stepType="currentStepType" :checkAgent="displayType" :generating="generating" :inputShowStop="showStop" :all-knowledge-color="allKnowledgeColor" :currentThread="currentThread" :searchWebEnabled="searchWebEnabled" :knowledgeEnabled="knowledgeEnabled"
            :folderTreeOptions="folderTreeOptions"
            @clearAgent="clearAgent" @queryQuestion='upsertQuestionData' @stopGenerate="onStopGenerate" )
            v-navigation-drawer.potaldrawer(v-model='drawer' absolute right hide-overlay :width="endPointDrawerWidth" style='z-index: 21;')
                portal-drawer-dialog(@emitPortalDrawer="onEmitPortalDrawer" @emitPD_remove_chunk="onEmitPD_Remove_Chunk" :selected-reference='selectedReference' :allKnowledgeColor='allKnowledgeColor' :allReferences='allReferences' :selectedQuestionid="selectedQuestionid" :showRemoveBtn="showRemoveBtn" :disableCopy="disableCopy")
            v-navigation-drawer.potaldrawer(v-model='relatedImagesDrawer' absolute right hide-overlay :width="endPointDrawerWidth" style='z-index: 21;')
                portal-relatedImages-drawer(@emitPortalRelatedImages="onEmitPortalRelatedImages" :mobileRelatedImages='mobileRelatedImages' :disableCopy="disableCopy")
            v-dialog(v-model='contentDialog' width='220' content-class='drawerDialog' hide-overlay open-delay=3 )
                portal-content-dialog(:contentMessage='contentMessage' :currentReference='currentReference' :key="dialogKey" )
        v-overlay(v-model='screenshoot_loading' z-index='990' opacity='.6')
            .d-flex.flex-column.align-center.text-center
                v-progress-circular(indeterminate color='#14C6DE')
                div.pt-1 {{$t('UPMEETING.WAITING')}}
        v-navigation-drawer.potaldrawer(v-model='showAddAgentDrawer' absolute right temporary stateless :width="endPointDrawerWidth" style='z-index: 30;')
            add-agent(@emitCloseAgentDrawer='onEmitCloseAgentDrawer' @getAgentListData='getAgentListData' :knowledge-list="knowledgeList" :knowledge-list-private="KnowledgeListPrivate" :dropdownSelectedKBList="dropdownSelectedKBList" :user_mode="true" :allKnowledgeColor="allKnowledgeColor" :folderTreeOptions="folderTreeOptions")
        v-navigation-drawer.potaldrawer(v-model='showEditAgentDrawer' absolute right temporary stateless :width="endPointDrawerWidth" style='z-index: 30;')
            edit-agent(@emitCloseAgentDrawer='onEmitCloseAgentDrawer' @getAgentListData='getAgentListData' @editDeleteFile="editDeleteFile"  @showErrorDialog="showErrorDialog" @getUserAgentDetail='getUserAgentDetail' :dropdownSelectedKBList="dropdownSelectedKBList" :agentdetail="agent_detail" :user_mode="true" :knowledge-list="knowledgeList" :knowledge-list-private="KnowledgeListPrivate" :allKnowledgeColor="allKnowledgeColor" :folderTreeOptions="folderTreeOptions")
        v-navigation-drawer.drawerShadow(v-model='showEditAdvanceAgentDrawer' absolute right temporary stateless :width="endPointDrawerWidth" style='z-index: 21;' )
            agent-detail-and-run-dialog(@emitAgentDetailAndRunDrawer='onEmitAgentDetailAndRunDrawer' @emitCloseAgentDrawer='onEmitCloseAgentDrawer' :addBtnLoading="childAddBtnLoading" :lock="childEditMode" :showrun="show_advance_agent_run_btn" :agentdetail="agent_detail" :FileAttachments="file_attachments" :ImageAttachments="image_attachments" :agentmode="agent_mode")
        v-dialog(v-model='documnet_agent_template_dialog' max-width='900' content-class='statusDialog')
            document-agent-template-dialog(@emitDocumentAgentTemplateDialog='onEmitDocumentAgentTemplateDialog' @emitCloseDocumentAgentTemplateDialog="onEmitCloseDocumentAgentTemplateDialog")
        v-dialog(v-model='ai_generate_dialog' max-width='720' content-class='statusDialog')
            document-agent-ai-generate-dialog(
                v-if='ai_generate_dialog'
                :loading='ai_generate_loading'
                :error-type='ai_generate_error_type'
                @emitAiGenerate='onEmitAiGenerate'
                @emitDirectCreate='onEmitDirectCreate'
            )
        v-dialog(v-model='errorDialog' width='360' content-class='statusDialog')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog')
            message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
        v-dialog(
            v-model='deleteAgentDialog'
            max-width='480'
            max-height='260'
            content-class='statusDialog'
        )
            delete-agent-dialog(
                :agent-name='deleteTargetName'
                @cancel='onDeleteUserAgentCancel'
                @confirm='onDeleteUserAgentConfirm'
            )
</template>

<script>
// import {inject} from "vue";
import { mapState, mapActions } from 'vuex';
import i18n from '/common/plugins/vue-i18n.js';
import VueMarkdown from 'vue-markdown-v2';
import { Pagination } from "@egjs/flicking-plugins";
import knowledge_color_group from "@/array/the_knowledgeColorGroup";
import UpGPTPortalDataServices from "../services/UpGPTPortalDataServices"
import KnowledgeLibraryService from "@/services/KnowledgeLibraryService";
import PersonalSettingService from "@/services/PersonalSettingService";
import AccountDataService from "@/services/AccountDataService";
import PreferenceService from "@/services/PreferenceService";
import passData from "@/services/passData.js";
import errorbackImage from '@/assets/images/notfundImagexl.jpg';
import MenuBarPortal from "@/layout/MenuBarPortal.vue";
import ThreadInputTab from "@/components/Portal/ThreadInputTab.vue";
import detailThreadInput from "@/components/Portal/detailThreadInput.vue";
import licenseWarningBanner from "@/components/Common/licenseWarningBanner.vue";
import portalLoadingSkeleton from "@/components/Portal/skeleton/portalLoadingSkeleton.vue";
import portalGenerateAnswerSkeleton from "@/components/Portal/skeleton/portalGenerateAnswerSkeleton.vue";
import portalDrawerDialog from "@/components/Portal/portaldrawerDialog";
import portalRelatedImagesDrawer from "@/components/Portal/portalRelatedImagesDrawer";
import portalContentDialog from "@/components/Portal/portalContentDialog";
import agentDetailAndRunDialog from "@/components/GPT_Common/agentDetailAndRunDialog";
import errorDialog from '@/components/Dialog/errorDialog';
import successDialog from "@/components/Dialog/successDialog";
import messageDialog from '@/components/Dialog/messageDialog';
import KnowledgeList from "@/components/Portal/KnowledgeList.vue";
import UserSetting from "../components/GPT_Common/UserSettingBlock.vue";
import addAgent from '../components/GPT_Common/addAgent.vue';
import editAgent from '../components/GPT_Common/editAgent.vue';
import agentCard from "@/components/Common/agentCard";
import documentAgentTemplateDialog from '@/components/DocumentAgent/documentAgentTemplateDialog';
import documentAgentAiGenerateDialog from '@/components/DocumentAgent/documentAgentAiGenerateDialog';
import deleteAgentDialog from '@/components/DocumentAgent/deleteAgentDialog';
import Knowledges_portal from "./main-views/Knowledges_portal.vue";
import knowledge from "../views-gpt/Knowledge.vue";
import DocumentAgent from "../views-gpt/DocumentAgentDetail.vue";
import Vue from 'vue';
import {fetchWithAuthRetry} from "../services/api/auth";

/* eslint-disable no-console */
// ─── Streaming helpers ─────────────────────────────────────────────────────
// Finds the index (exclusive) of the closing `}` that completes the first
// top-level JSON object in `str`.  Returns -1 if the object is not yet complete.
// String-aware: handles escaped quotes and nested braces inside string values.
function findJSONEnd(str) {
    if (!str.startsWith('{')) return -1;
    let depth = 0, inString = false, escape = false;
    for (let i = 0; i < str.length; i++) {
        const c = str[i];
        if (escape)              { escape = false; continue; }
        if (c === '\\' && inString) { escape = true;  continue; }
        if (c === '"')           { inString = !inString; continue; }
        if (inString)            continue;
        if (c === '{')           depth++;
        else if (c === '}')      { if (--depth === 0) return i + 1; }
    }
    return -1;
}
// Splits `buf` into the next complete unit and the remaining buffer.
// Only treats `{"pid":` as a JSON boundary; all other text is yielded immediately
// so real-time display is unaffected.  Returns null when more data is needed.
function extractUnit(buf) {
    if (!buf) return null;
    const start = buf.indexOf('{"pid":');
    if (start === -1) return [buf, ''];           // no JSON ahead — yield all
    if (start > 0)   return [buf.slice(0, start), buf.slice(start)]; // text first
    const end = findJSONEnd(buf);
    if (end === -1)  return null;                  // incomplete JSON — wait
    return [buf.slice(0, end), buf.slice(end)];
}
// Async generator that wraps a ReadableStream reader.
// Guarantees: `{"pid":...}` is always yielded as a standalone, complete string.
async function* streamChunks(reader, decoder) {
    let buf = '';
    while (true) {
        const { done, value } = await reader.read();
        if (value) {
            const raw = decoder.decode(value, { stream: true });
            console.log('[STREAM] raw read ──►', JSON.stringify(raw));
            buf += raw;
        }
        let ex;
        while ((ex = extractUnit(buf)) !== null) {
            const [unit, rest] = ex;
            buf = rest;
            if (unit) {
                console.log('[STREAM] yield unit ──►', JSON.stringify(unit), '| remaining buf:', JSON.stringify(rest));
                yield unit;
            }
        }
        if (buf && !done) console.log('[STREAM] waiting for more data, buf so far:', JSON.stringify(buf));
        if (done) { if (buf) yield buf; return; }
    }
}
// Finds the end of a `data:...[[<<REPLACE>>]]` frame used by the agent-run stream.
// Returns [frame, remaining] or null when the frame is not yet complete.
function extractFrame(buf) {
    const TERM = '[[<<REPLACE>>]]';
    const end = buf.indexOf(TERM);
    if (end === -1) return null;
    return [buf.slice(0, end + TERM.length), buf.slice(end + TERM.length)];
}
// Variant of streamChunks for agent-run streaming, which wraps every message in
// `data:...[[<<REPLACE>>]]` framing — yields exactly one complete frame at a time.
async function* streamFrames(reader, decoder) {
    let buf = '';
    while (true) {
        const { done, value } = await reader.read();
        if (value) {
            const raw = decoder.decode(value, { stream: true });
            console.log('[STREAM] raw read (agent) ──►', JSON.stringify(raw));
            buf += raw;
        }
        let ex;
        while ((ex = extractFrame(buf)) !== null) {
            const [frame, rest] = ex;
            buf = rest;
            if (frame) {
                console.log('[STREAM] yield frame ──►', JSON.stringify(frame));
                yield frame;
            }
        }
        if (buf && !done) console.log('[STREAM] waiting for frame end, buf so far:', JSON.stringify(buf));
        if (done) { if (buf) yield buf; return; }
    }
}
// ───────────────────────────────────────────────────────────────────────────
/* eslint-enable no-console */

export default {
    name: 'UpPortalDetail',
    props: {
        member: {
            type: Object
        }
    },
    components: {
        MenuBarPortal,
        ThreadInputTab,
        detailThreadInput,
        licenseWarningBanner,
        portalLoadingSkeleton,
        portalGenerateAnswerSkeleton,
        Knowledges_portal,
        knowledge,
        // Agents,
        KnowledgeList,
        UserSetting,
        agentCard,
        addAgent,
        editAgent,
        portalDrawerDialog,
        portalRelatedImagesDrawer,
        portalContentDialog,
        agentDetailAndRunDialog,
        VueMarkdown,
        errorDialog,
        messageDialog,
        successDialog,
        documentAgentTemplateDialog,
        documentAgentAiGenerateDialog,
        DocumentAgent,
        deleteAgentDialog,
    },
    data() {
        return{
            childAddBtnLoading: false,
            childEditMode: true,
            loading:false,
            generating:false,
            showStop: false,
            genSeq: 0,
            stopRequested: false,
            stopSentMap: {},
            generatingTitle: '',        
            is_new_insert:true,
            is_user_setting: false,
            is_knowledges: false,
            is_knowledge: false,
            is_agents: false,
            is_document_agent: false,
            searchQuery: "", // 綁定搜尋輸入
            results: [], // 存儲搜尋結果
            new_question: true,
            showGenerateAnsSkeleton: true,
            // reaponse.data.questions
            user_iput_question: '',
            portalDetails:[],
            toDeleteData:{},
            portalDetailsMap:{},
            knowledgeList:[],
            allKnowledgeColor:[],
            questionKnowledgeList:[],
            knowledge_color_group:knowledge_color_group,
            selectedKnowledgeLibs:[],
            dropdownSelectedKBList:[],
            knowledgeListShowAll:9,
            knowledgeDefaultLength:9,
            selectedReference:{},
            targetQustion_Obj:{},
            allReferences:[],
            showAllImage: true,
            errorImg: false,
            thumb_up:false,
            thumb_down:false,
            drawer:false,
            relatedImagesDrawer:false,
            copied:false,
            errorDialog: false,
            errorMessage: '',
            current_thread_id:'',
            currentThread:{},
            searchWebEnabled:false,
            knowledgeEnabled:true,
            folderTreeOptions:[],
            contentMessage:'',
            currentReference:{},
            contentDialog: false,
            hoverTimeout:'',
            referenceDisplayNum:3,
            dialogKey:0,
            selectedQuestionid:'',
            errorbackImage: errorbackImage,
            companylogo_url:"",
            disableCopy: false,
            // mobile tag
            currentPortalDetailIndex: null,
            streamingId:{},
            currentStepType:'',
            displayType:'',
            mobileTags:[
                {
                    id:0,
                    type:'Answer',
                    fullName: i18n.t('PORTAL.ANSWER'),
                    image:require("@/assets/images/ans-book.svg")
                },
                {
                    id:1,
                    type:'RelatedImages',
                    fullName: i18n.t('PORTAL.RelatedImages'),
                    image:require("@/assets/images/related-images-icon.svg")
                },
                {
                    id:2,
                    type:'Related',
                    fullName: i18n.t('PORTAL.Related'),
                    image:require("@/assets/images/related-ans-icon.svg")
                },
                {
                    id:3,
                    type:'Reference',
                    fullName: i18n.t('PORTAL.REFERENCE'),
                    image:require("@/assets/images/reference-icon.svg")
                },
            ],
            selectedMobileTagType: 'Answer',
            mobileQuestion:{},
            mobileRelated: [],
            mobileRelatedImages:[],
            mobileReference:'',
            showRemoveBtn: true,
            plugins: [new Pagination({ type: 'bullet' })],
            // UserSetting
            board_contact_sync:false,
            locationName: i18n.locale == 'zh_TW'? "name" : "en_name",
            userLanguage:'',
            userLocation:'',
            userImageId:null,
            userID:null,
            userImage:null,
            userPhoto:"",
            isUserPhoto:false,
            message:"",
            messageDialog:false,
            successDialog:false,
            valid:false,
            languageList: [{key:'zh_TW',name:'繁體中文'},{key:'zh_CN',name:'简体中文'},{key:'en_US',name:'English'},{key:'ja_JP',name:'日本語'}],
            personal: {
            firstName: 'James',
            lastName: 'Campbell',
            mail: 'James@gmail.com',
            mailDisabled: true,
            currency: 'TWD(新台幣)',
            currencyDisabled: true,
            language: 'zh_TW',
            },
            userData:{},
            formRule: {
                nameRules: [
                            (v) => !!v || i18n.t('RULE.RULE_R_LASTNAME_3'),
                            (v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')
                        ],
                firstNameRules: [(v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')],
                emailRules: [(v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|(^$)|null/.test(v) || i18n.t('RULE.RULE_EMAIL')],
                phoneRules: [(v) => /^09\d{8}$|(^$)|null/.test(v) || i18n.t('RULE.RULE_PHONE')],
                fieldRules: [(v) => !!v || i18n.t('RULE.RULE_R')],
            },
            newPicUrl:'',
            newName:{},
            opptyProcess: null,
            caseProcess: null,
            allow_web_push: true,
            allow_follow: true,
            allow_mention: true,
            allow_reply: true,
            allow_emoji: true,
            password: {
                current: '',
                new: '',
                confirm: '',
            },
            passwordCheck:null,
            confirmPasswordCheck:null,
            haveChange: false,
            change_password: null,
            delMode: null,
            //My Knowledge
            knowledge_id: '',
            KnowledgeListPrivate:[],
            // Agent
            show_advance_agent_run_btn: true,
            showAddAgentDrawer: false,
            showEditAgentDrawer: false,
            howEditSimpleAgentDrawer: false,
            showEditAdvanceAgentDrawer: false,
            // Agent Filter
            agentfilterStyleList: [
                {name: 'Simple Agent', key: 'simple_agent', active: true},
                {name: 'Advanced Agent', key: 'advanced_agent', active: false},
            ],
            agentfilterPolicyList:[
                {name: 'Private', key: 'private', active: false},
                {name: 'Public', key: 'public', active: false},
            ],
            AgentsList: {},
            agent_style: "simple",
            agent_definition_mode: null,
            agent_detail: {},
            hide_ans_without_ref: false,
            agent_to_userInput: {},
            del_agent_detail: {},
            image_attachments: [],
            file_attachments: [],
            agent_mode: "private",
            // Document Agent
            documnet_agent_template_dialog: false,
            doc_agent_id: "",
            doc_agent_data: {},
            // AI Generate Dialog
            ai_generate_dialog: false,
            ai_generate_loading: false,
            ai_generate_error_type: null,
            // extension
            api_data:{api_key:null,tenant:null},
            aisearch:'',
            upside_tenant: '',
            screenshoot_loading: false,
            isUpsideLogout: false,
            show_private_knowledge:false,
            show_private_knowledge_add_btn:false,
            // 客製外觀參數
            portal_background: "#FCFBF7",
            references_border: "#14C6DE",
            answer_bottom_border: "#14C6DE",
            new_question_btn: document.documentElement.style.getPropertyValue('--new_question_btn'),
            deleteAgentDialog: false,
            deleteTargetName: '',
        };
    },
    async created() {
        var user = JSON.parse(window.localStorage.getItem('user'));
        var tenant = window.localStorage.getItem('tenant');
        window.addEventListener('message', this.loginMessage, false);
        parent.postMessage({
            isUpday:true,
            from: "UpMeeting_AUTO_Login",
            value: [user,tenant]
        }, "*")
        window.addEventListener('message', this.receiveMessage, false);

        // 進入 Portal 時查詢一次授權狀態；送出訊息前還會再查一次（見兩個輸入元件）。
        // 不 await：查不到時 action 會保留現有值，不該讓授權查詢拖慢畫面載入。
        this.$store.dispatch('fetchLicenseStatus');

        await this.getPortalColorSetting();
        await this.getPortalDisableCopy();
        await this.getUserDetail();
        await this.getCustomCompanyLogo();
        await this.getKnowledgeList();
        await this.getKnowledgeListPrivate();
        // await this.getKnowledgeFolderTree();
        await this.defaultColorKnowledgeList();
        await this.applyDefaultAgentType();
        await this.getAgentListData();
        await this.getPortalHideAnsWithoutRef();
        // 公共+私人知識庫
        this.selectedKnowledgeLibs = [...this.knowledgeList, ...this.KnowledgeListPrivate];
        this.dropdownSelectedKBList = [...this.knowledgeList, ...this.KnowledgeListPrivate];

        // Onedrive login redirect
        this.redirectAgentId();
        await this.if_private_knowledge();
    },
    mounted(){
        this.setBodyStyle();
        const observer = new MutationObserver(() => {
            this.bindingEvent();
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        this.setAnswerLinkTarget();
    },
    updated(){
        this.setAnswerLinkTarget();
    },
    methods: {
        // for search knowledge content display
        // formatContent(content) {
        //     if (Array.isArray(content)) content = content.join(" ");
        //     return content && content.length > 200 ? content.slice(0, 200) + "..." : content;
        // },
        async applyDefaultAgentType() {
            try {
                const response = await PreferenceService.getUPGPTSetting();
                const defaultType = response.data?.default_agent_type;
                if (defaultType === 'advanced') {
                    this.agentfilterStyleList.forEach(f => {
                        f.active = f.key === 'advanced_agent';
                    });
                    this.agent_style = 'advance';
                }
            } catch {
                // 靜默忽略，保持預設行為（Simple Agent active）
            }
        },
        async getPortalHideAnsWithoutRef(){
          await UpGPTPortalDataServices.GetPortalHideAnsWithoutRef().then(res=>{
              console.log(res);
              this.hide_ans_without_ref = res.data;
          })
        },
        async getPortalDisableCopy(){
            await PreferenceService.getPortalDisableCopy().then((response) => {
                this.disableCopy = !!response.data;
            }).catch(() => {
                this.disableCopy = false;
            });
        },
        async getCustomCompanyLogo(){
            await UpGPTPortalDataServices.getCustomCompanyLogo().then((response) => {
                let src = response.data;
                if(src!="Not_uploaded"){
                    this.companylogo_url = src;
                }else{
                    this.companylogo_url = "default";
                }
            })
        },
        async getPortalColorSetting() {
            let color_setting;
            const root = document.documentElement;
            await PreferenceService.getPortalColorSetting().then((response)=>{
                color_setting = response.data;
                if (color_setting) {
                    root.style.setProperty('--portal_background', color_setting.portal_background);
                    root.style.setProperty('--references_border', color_setting.references_border);
                    root.style.setProperty('--answer_bottom_border', color_setting.answer_bottom_border);
                    this.portal_background = color_setting.portal_background;
                    this.references_border = color_setting.references_border;
                    this.answer_bottom_border = color_setting.answer_bottom_border;
                    this.new_question_btn = color_setting.new_question_btn;
                } else {
                    root.style.setProperty('--portal_background', "#FCFBF7");
                    root.style.setProperty('--references_border', "#14C6DE");
                    root.style.setProperty('--answer_bottom_border', "#14C6DE");
                    this.portal_background = "#FCFBF7";
                    this.references_border = "#14C6DE";
                    this.answer_bottom_border = "#14C6DE";
                    this.new_question_btn = "#14C6DE";
                }
            })
        },
        // ===== 停止回答：前端立即重置 =====
        // 每次提問給一個流水號，回傳給串流函式當作自己的 seq
        beginGenerate(title = ''){
            this.genSeq += 1;
            this.stopRequested = false;
            this.streamingId = {};
            this.generating = true;
            this.showStop = true;   // 一提問就可以按停止
            this.generatingTitle = title;
            return this.genSeq;
        },
        // 這條串流是否已被停止，或已經有更新的提問
        isAbandoned(seq){
            return seq !== this.genSeq || this.stopRequested;
        },
        onStopGenerate(){
            if (!this.generating || this.stopRequested) return;
            const seq = this.genSeq;
            this.stopRequested = true;
            // 1. 立刻重置畫面狀態
            this.generating = false;
            this.showStop = false;
            this.loading = false;
            this.portalDetails.forEach(item => {
                if (item && item.generating) {
                    this.$set(item, 'generating', false);
                    this.$set(item, 'isSkeleton', false);
                    this.$set(item, 'stopped_seq', seq);
                }
            });
            // 新對話第一輪：卡片還沒放進畫面就按停止 → 先放一張「已停止」的卡
            if (this.portalDetails.length === 0) {
                this.portalDetails = [{
                    type: '',
                    upsert_type: 'insert',
                    question_id: '',
                    question_title: this.generatingTitle,
                    question_on: new Date(),
                    knowledges: this.selectedKnowledgeLibs || [],
                    content: '',
                    references: [],
                    related_image: [],
                    related: [],
                    tabs: [{ id: 1, key: 'Answer', name: i18n.t('AGENT_STEP.ANSWER') }],
                    tabs_current: 'tab-1',
                    step_flow: [],
                    step_current: [],
                    isSkeleton: false,
                    generating: false,
                    reasoning_thinking: '',
                    function_calling: '',
                    stopped_seq: seq,
                }];
            }
            // 2. 已拿到 streamingId 就馬上通知後端；還沒拿到的話，串流收到 pid 時會補送
            this.sendStopOnce(seq, this.streamingId);
        },
        sendStopOnce(seq, sid){
            if (!sid || sid.pid === undefined || sid.pid === null) return;
            if (this.stopSentMap[seq]) return;   // 每條串流只送一次
            this.stopSentMap[seq] = true;
            UpGPTPortalDataServices.stopStreaming(sid).catch(e => {
                console.warn('[STREAM] stopStreaming failed', e);
            });
        },
        // 已停止的串流：畫面不再更新，只收集 pid / question_id
        handleStoppedChunk(seq, chunkText, stopState){
            const pidMatch = chunkText.match(/\{"pid":(\d+),"tid":(\d+),"offset":(\d+)\}/);
            if (pidMatch) {
                stopState.sid = { pid: Number(pidMatch[1]), tid: Number(pidMatch[2]), offset: Number(pidMatch[3]) };
            }
            const qMatch = chunkText.match(/<QUESTION_ID>(.*?)<QUESTION_ID>/);
            if (qMatch && qMatch[1]) {
                stopState.question_id = qMatch[1];
            }
            if (stopState.sid) this.sendStopOnce(seq, stopState.sid);
        },
        // 已停止的串流在背景讀完後：換成資料庫版本並刷新對話列表
        // 已停止的串流在背景讀完後：只補 question_id / 時間，內容維持停止當下的樣子
        async finishStoppedStream(seq, stopState, selectFirstThread = false){
            try {
                if (stopState.question_id) {
                    const detail = await this.questionDetailData(stopState.question_id);
                    const idx = this.portalDetails.findIndex(item => item && item.stopped_seq === seq);
                    if (idx >= 0) {
                        const card = this.portalDetails[idx];
                        this.$set(card, 'question_id', stopState.question_id);
                        if (detail) {
                            this.$set(card, 'question_on', detail.question_on);
                            this.$set(card, 'answer_on', detail.answer_on);
                        }
                        this.$set(card, 'isSkeleton', false);
                        this.$set(card, 'generating', false);
                        await this.getQuestionKnowledge(stopState.question_id);
                    } else if (detail && selectFirstThread && seq === this.genSeq) {
                        // 開新對話時太早按停止，畫面上還沒有卡片：只顯示問題，回答顯示中斷
                        detail.content = '';
                        detail.reasoning_thinking = '';
                        detail.references = [];
                        detail.related = [];
                        detail.related_image = [];
                        detail.step_flow = [];
                        detail.tabs_current = 'tab-1';
                        detail.isSkeleton = false;
                        detail.generating = false;
                        detail.stopped_seq = seq;
                        this.portalDetails = [detail];
                        await this.getQuestionKnowledge(stopState.question_id);
                    }
                }
                await this.$refs.menuBarPortal.getThreadListData();
                // 使用者還沒開始下一題，才同步目前對話
                if (seq === this.genSeq) {
                    if (selectFirstThread) await this.$refs.menuBarPortal.set_selected_thread(0);
                    if (this.current_thread_id) await this.$refs.menuBarPortal.updateCurrentThread(this.current_thread_id);
                }
            } catch (e) {
                console.warn('[STREAM] finishStoppedStream failed', e);
            }
        },
        async createThread(data) {
            this.loading = true;
            const seq = this.beginGenerate(data.text);
            try {
            this.is_new_insert = false;
            this.searchWebEnabled=data.use_web_search;
            this.knowledgeEnabled=data.use_knowledge_lib;
            // =========== 這裡是原本 portal 的streaming ============
            this.user_iput_question = data.text;
            this.selectedKnowledgeLibs = data.category;
            // 使用 response_createThread.data.thread_id 來獲取 thread_id
            let data_createThread = {"question": data.text};
            let response_createThread = await UpGPTPortalDataServices.createThread(data_createThread);
            this.current_thread_id = response_createThread.data.thread_id
            let jsonArray = [];
            let formData = new FormData();
            formData.append("thread_id", this.current_thread_id);
            formData.append("question_id", '');
            formData.append("question", data.text);
            formData.append("knowledges", JSON.stringify(this.selectedKnowledgeLibs));
            formData.append("general_instructions", data.general_instructions);
            formData.append("use_web_search", data.use_web_search);
            formData.append("use_knowledge_lib", data.use_knowledge_lib);
            if(data.attchements){
                data.attchements.forEach(file => {
                    if(this.isFileType(file)){
                        // 檔案 → append 到 attach_document_files
                        formData.append("attach_document_files", file);
                    }else{
                        // 描述檔案 → append 到 attach_document_json
                        jsonArray.push(file);
                    }
                    formData.append("attach_document_json", JSON.stringify(jsonArray))
                })
            }

            await this.getKnowledgeList();
            await this.getKnowledgeListPrivate();
            // ========================= Streaming =========================
            // Call Streaming API
            let PUBLIC_URL = process.env.VUE_APP_API_BASE_URL;
            let BASE_URL = PUBLIC_URL + '/tenant';
            const { resp: stream_res, refreshFailed } = await fetchWithAuthRetry(`${BASE_URL}/${window.localStorage.getItem('tenant')}/api/upgpt_portal/thread/${this.current_thread_id}/`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('access_token')}`,
                },
                body: formData
            });
            if (refreshFailed) {
                this.showErrorDialog(i18n.t('PORTAL.ERROR_4'));
                // let tenant = window.localStorage.getItem('tenant');
                // // if token refresh fails, logout the user to avoid potential security risks.
                // logoutUser();
                // if (tenant != null || tenant != '')
                //   window.location.href = `/login?tenant=${tenant}`;
                // else
                //   window.location.href = '/login';
            }
            // 處理接到的值
            let reader = stream_res.body.getReader();
            let decoder = new TextDecoder('utf-8');

            // 將接到的資料依序顯示
            let finish = false;
            let current_question_id = '';
            let detect_area = "";
            let text_buffer = "";
            let start_collect_thinking = false;
            let start_collect_answer = false;
            const MARKER_REGEX = /reasoning_step"?\s*:/; // { 和開頭 " 可能被 pid/tid 邏輯丟棄
            const MARKER_FINALANS_REGEX = /","final_answer":"/;
            let chunk = {
                type: '',
                upsert_type: 'insert',
                question_id: '',
                question_title: this.user_iput_question,
                question_on: new Date(),
                knowledges: this.selectedKnowledgeLibs,
                content: '',
                references: [],
                related_image: [],
                related: [],
                tabs:[{
                    id: 1,
                    key: 'Answer',
                    name: i18n.t('AGENT_STEP.ANSWER')
                }],
                tabs_current: "tab-1",
                step_flow: [],
                step_current: [],
                isSkeleton: true,
                generating: true,
                reasoning_thinking: "",
                function_calling: "",
                use_web_search: data.use_web_search,
                use_knowledge_lib: data.use_knowledge_lib
            };
            if (!this.isAbandoned(seq)) {
                this.portalDetails = [chunk];
            }
            const stopState = { sid: null, question_id: '' };
            for await (let chunkText of streamChunks(reader, decoder)) {
                if (this.isAbandoned(seq)) {
                    this.handleStoppedChunk(seq, chunkText, stopState);
                    continue;
                }
                this.loading = false;
                // console.log('text',chunkText); // Streaming檢查用
                // 在Streaming的最後會回傳ID 例如: <QUESTION_ID>10bed418-55b6-4019-8daf-2cd5917ceef8<QUESTION_ID>
                if(chunkText.includes('<QUESTION_ID>')){
                    let match = chunkText.match(/<QUESTION_ID>(.*?)<QUESTION_ID>/);
                    if(match && match[1]){
                        current_question_id = match[1];
                        // console.log('current_question_id',current_question_id); // Streaming檢查用
                        chunk.question_id = current_question_id;
                    }
                    chunk.reasoning_thinking = "";
                    chunk.type = 'final';
                }
                // 存streaming pid tid — streamChunks 保證此 unit 是完整 JSON 物件
                if (chunkText.startsWith('{"pid":')) {
                    try {
                        const obj = JSON.parse(chunkText);
                        if ("pid" in obj && "tid" in obj && "offset" in obj) {
                            // eslint-disable-next-line no-console
                            console.log('[STREAM] streamingId set ──►', obj);
                            this.streamingId = obj;
                        }
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.warn('[STREAM] JSON.parse failed for pid unit:', chunkText, e);
                    }
                }

                // 只有在 chunk.type 不是 final 時才處理 text_buffer 的內容
                if (chunk.type !== 'final') {
                    this.showStop = true;
                    detect_area += chunkText;
                    if(chunkText.includes('[Tool Call]')){
                        chunkText = chunkText.replace('[Tool Call]', '取得工具搜尋');
                        chunk.function_calling += '\n' + chunkText;
                    }
                    if(detect_area.match(MARKER_REGEX)){
                        // console.log('------------------------抓到reasoning-----------------------------')
                        chunk.function_calling = "";
                        start_collect_thinking = true;
                        detect_area = "";
                    }
                    if(detect_area.match(MARKER_FINALANS_REGEX)){
                        // 從 detect_area 取出 marker 後的真實內容，避免 chunk 邊界切斷造成 JSON key 殘留
                        const _fm = '","final_answer":"';
                        const _fpos = detect_area.indexOf(_fm);
                        chunkText = _fpos >= 0 ? detect_area.slice(_fpos + _fm.length) : '';
                        detect_area = "";
                        chunk.function_calling = "";
                        start_collect_thinking = false;
                        start_collect_answer = true;
                    }
                    // 開始蒐集reasoning文字
                    if(start_collect_thinking){
                        this.showGenerateAnsSkeleton = false;
                        chunkText = this.cleanChunkPattern(chunkText);
                        chunk.reasoning_thinking  += chunkText;
                    }
                    // 開始蒐集FINALANSWER文字
                    if(start_collect_answer) {
                        if(chunkText.includes('取得工具搜尋')){
                            chunk.function_calling += '\n' + chunkText;
                        }else{
                            if(chunkText.includes('related')){
                                detect_area = "";
                                chunk.content = "";
                                chunk.reasoning_thinking = "";
                                start_collect_thinking = false;
                                start_collect_answer = false;
                            }
                            chunkText = this.cleanChunkPattern(chunkText);
                            text_buffer += chunkText;
                            chunk.content = text_buffer;
                        }

                    }
                    // console.log('text_buffer',text_buffer) // Streaming檢查用
                    if(text_buffer.includes('<FINAL>')){
                        text_buffer = text_buffer.replace('<FINAL>', '');
                    }

                }
                // 如果為 final，設定內容並結束
                if (chunk.type === 'final') {
                    text_buffer = text_buffer.replace(/<QUESTION_ID>.*?<QUESTION_ID>/g, '').trim();
                    chunk.content = text_buffer;
                    let questionDetailData = await this.questionDetailData(chunk.question_id);
                    chunk = questionDetailData ? questionDetailData : chunk;
                    chunk.tabs_current = 'tab-1';
                    finish = true; // 結束迴圈標記
                    chunk.isSkeleton = false;
                    // if (response_relateds.data.length <= 0) {
                    //     chunk.content = i18n.t('PORTAL.ERROR_3');
                    // }
                    await this.$refs.menuBarPortal.getThreadListData();
                    await this.$refs.menuBarPortal.set_selected_thread(0);
                    await this.getQuestionKnowledge(current_question_id);
                    this.generating = false;
                    chunk.generating = false;
                    this.showStop = false;
                }
                let array = []
                array.push(chunk)
                this.portalDetails = array
                if (finish) break;
            }
            if (this.isAbandoned(seq)) {
                await this.finishStoppedStream(seq, stopState, true);
                return;
            }
            // this.clearAgent(); // 重設simple agent
            this.agent_to_userInput={};
            this.currentThread={};
            await this.$refs.menuBarPortal.updateCurrentThread(this.current_thread_id);
            } finally {
                if (seq === this.genSeq) {
                    if (this.generating) {
                        console.warn('[STREAM] createThread 未正常結束(後端中斷/連線關閉)，強制重置狀態');
                    }
                    this.generating = false;
                    this.showStop = false;
                    this.loading = false;
                }
            }
        },
        async upsideAIAnswer(data){
            this.loading = true;
            const seq = this.beginGenerate(data.type_question);
            try {
            this.is_new_insert = false;
            this.searchWebEnabled=false;
            this.knowledgeEnabled=true;

            let raw_instruction;
             // 使用 answer_api_type 來判斷 'reply' call aireplymessageanswer, 'problem' call aigenerateproblemanswer
            if(data.answer_api_type == 'reply'){
                let mapping_type = {
                    "other": "website_content",
                    "chat": "chat_history",
                    "email": "email_content"
                }
                // 組合instruction
                if (data.type == "email"){
                    raw_instruction = "Email Title:"+data["email_title"] + "\n" + data["email_content"]
                }else{
                    raw_instruction =data[mapping_type[data.type]];
                }
            }else if(data.answer_api_type == 'problem'){
                raw_instruction = data["problem_analysis"]
            }

            this.user_iput_question = data.type_question;
            this.current_thread_id = data.thread_id;
            this.selectedKnowledgeLibs = [...this.knowledgeList, ...this.KnowledgeListPrivate];

            let upsertdata = {
                "thread_id":this.current_thread_id,
                "question_id": '',
                "question": this.user_iput_question,
                "knowledges":this.selectedKnowledgeLibs,
                "general_instructions": raw_instruction,
                "isUpsideAgent": true,
            }
            if(data.answer_api_type == 'reply'){
                upsertdata["type"] = data.type;
                upsertdata["isVision"] = data.isVision;
            }else if(data.answer_api_type == 'problem'){
                upsertdata["title"] = data.title;
                upsertdata["problem_analysis"] = data.problem_analysis;
            }
            // ========================= Streaming =========================
            let upside_denerate_answer_type = data.answer_api_type=="reply" ? "aireplymessageanswer" : "aigenerateproblemanswer"
            // Call Streaming API
            let PUBLIC_URL = process.env.VUE_APP_API_BASE_URL;
            let BASE_URL = PUBLIC_URL + '/tenant';
             const { resp: stream_res, refreshFailed } = await fetchWithAuthRetry(`${BASE_URL}/${window.localStorage.getItem('tenant')}/api/copilot/upgpt/${upside_denerate_answer_type}/`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('access_token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(upsertdata)
            });
            if (refreshFailed) {
                this.showErrorDialog(i18n.t('PORTAL.ERROR_4'));
                // let tenant = window.localStorage.getItem('tenant');
                // // if token refresh fails, logout the user to avoid potential security risks.
                // logoutUser();
                // if (tenant != null || tenant != '')
                //   window.location.href = `/login?tenant=${tenant}`;
                // else
                //   window.location.href = '/login';
            }
            // 處理接到的值
            let reader = stream_res.body.getReader();
            let decoder = new TextDecoder('utf-8');

            // 將接到的資料依序顯示
            let finish = false;
            let current_question_id = '';
            let detect_area = "";
            let text_buffer = "";
            let start_collect_thinking = false;
            let start_collect_answer = false;
            const MARKER_REGEX = /reasoning_step"?\s*:/; // { 和開頭 " 可能被 pid/tid 邏輯丟棄
            const MARKER_FINALANS_REGEX = /","final_answer":"/;
            let chunk = {
                type: '',
                upsert_type: 'insert',
                question_id: '',
                question_title: this.user_iput_question,
                question_on: new Date(),
                knowledges: this.selectedKnowledgeLibs,
                content: '',
                references: [],
                related_image: [],
                related: [],
                tabs:[{
                    id: 1,
                    key: 'Answer',
                    name: i18n.t('AGENT_STEP.ANSWER')
                }],
                tabs_current: "tab-1",
                step_flow: [],
                step_current: [],
                isSkeleton: true,
                generating: true,
                reasoning_thinking: "",
                function_calling: "",
                use_web_search: false,
                use_knowledge_lib: true
            };
            if (!this.isAbandoned(seq)) {
                this.portalDetails = [chunk];
            }
            const stopState = { sid: null, question_id: '' };
            for await (let chunkText of streamChunks(reader, decoder)) {
                if (this.isAbandoned(seq)) {
                    this.handleStoppedChunk(seq, chunkText, stopState);
                    continue;
                }
                this.loading = false;
                // console.log('text',chunkText); // Streaming檢查用
                // 在Streaming的最後會回傳ID 例如: <QUESTION_ID>10bed418-55b6-4019-8daf-2cd5917ceef8<QUESTION_ID>
                if(chunkText.includes('<QUESTION_ID>')){
                    let match = chunkText.match(/<QUESTION_ID>(.*?)<QUESTION_ID>/);
                    if(match && match[1]){
                        current_question_id = match[1];
                        // console.log('current_question_id',current_question_id); // Streaming檢查用
                        chunk.question_id = current_question_id;
                    }
                    chunk.reasoning_thinking = "";
                    chunk.type = 'final';
                }
                // 存streaming pid tid — streamChunks 保證此 unit 是完整 JSON 物件
                if (chunkText.startsWith('{"pid":')) {
                    try {
                        const obj = JSON.parse(chunkText);
                        if ("pid" in obj && "tid" in obj && "offset" in obj) {
                            // eslint-disable-next-line no-console
                            console.log('[STREAM] streamingId set ──►', obj);
                            this.streamingId = obj;
                        }
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.warn('[STREAM] JSON.parse failed for pid unit:', chunkText, e);
                    }
                }

                // 只有在 chunk.type 不是 final 時才處理 text_buffer 的內容
                if (chunk.type !== 'final') {
                    this.showStop = true;
                    detect_area += chunkText;
                    if(chunkText.includes('[Tool Call]')){
                        chunkText = chunkText.replace('[Tool Call]', '取得工具搜尋');
                        chunk.function_calling += '\n' + chunkText;
                    }
                    if(detect_area.match(MARKER_REGEX)){
                        // console.log('------------------------抓到reasoning-----------------------------')
                        chunk.function_calling = "";
                        start_collect_thinking = true;
                        detect_area = "";
                    }
                    if(detect_area.match(MARKER_FINALANS_REGEX)){
                        // 從 detect_area 取出 marker 後的真實內容，避免 chunk 邊界切斷造成 JSON key 殘留
                        const _fm = '","final_answer":"';
                        const _fpos = detect_area.indexOf(_fm);
                        chunkText = _fpos >= 0 ? detect_area.slice(_fpos + _fm.length) : '';
                        detect_area = "";
                        chunk.function_calling = "";
                        start_collect_thinking = false;
                        start_collect_answer = true;
                    }
                    // 開始蒐集reasoning文字
                    if(start_collect_thinking){
                        this.showGenerateAnsSkeleton = false;
                        chunkText = this.cleanChunkPattern(chunkText);
                        chunk.reasoning_thinking  += chunkText;
                    }
                    // 開始蒐集FINALANSWER文字
                    if(start_collect_answer) {
                        if(chunkText.includes('取得工具搜尋')){
                            chunk.function_calling += '\n' + chunkText;
                        }else{
                            if(chunkText.includes('related')){
                                detect_area = "";
                                chunk.content = "";
                                chunk.reasoning_thinking = "";
                                start_collect_thinking = false;
                                start_collect_answer = false;
                            }
                            chunkText = this.cleanChunkPattern(chunkText);
                            text_buffer += chunkText;
                            chunk.content = text_buffer;
                        }

                    }
                    // console.log('text_buffer',text_buffer) // Streaming檢查用
                    if(text_buffer.includes('<FINAL>')){
                        text_buffer = text_buffer.replace('<FINAL>', '');
                    }

                }
                // 如果為 final，設定內容並結束
                if (chunk.type === 'final') {
                    text_buffer = text_buffer.replace(/<QUESTION_ID>.*?<QUESTION_ID>/g, '').trim();
                    chunk.content = text_buffer;
                    let questionDetailData = await this.questionDetailData(chunk.question_id);
                    chunk = questionDetailData ? questionDetailData : chunk;
                    chunk.tabs_current = 'tab-1';
                    finish = true; // 結束迴圈標記
                    chunk.isSkeleton = false;
                    await this.$refs.menuBarPortal.getThreadListData();
                    await this.$refs.menuBarPortal.set_selected_thread(0);
                    await this.getQuestionKnowledge(current_question_id);
                    this.generating = false;
                    chunk.generating = false;
                    this.showStop = false;
                }
                let array = []
                array.push(chunk)
                this.portalDetails = array
                if (finish) break;
            }
            if (this.isAbandoned(seq)) {
                await this.finishStoppedStream(seq, stopState, true);
                this.afterUpsideAnswerGenerate();
                return;
            }
            this.agent_to_userInput={};
            this.currentThread={};
            this.afterUpsideAnswerGenerate();
            } finally {
                if (seq === this.genSeq) {
                    if (this.generating) {
                        console.warn('[STREAM] upsideAIAnswer 未正常結束(後端中斷/連線關閉)，強制重置狀態');
                    }
                    this.generating = false;
                    this.showStop = false;
                    this.loading = false;
                }
            }
        },
        afterUpsideAnswerGenerate(){
            console.log("Vue afterUpsideAnswerGenerate")
            parent.postMessage({
                isUpday:true,
                from: "after AI generate finish",
                value:"after AI generate finish"
              }, "*")
        },
        isFileType(obj) {
            return obj instanceof File || Object.prototype.toString.call(obj) === '[object File]';
        },
        async set_main_view(){
            this.is_user_setting= false;
            this.is_new_insert = false;
            this.is_knowledges = false;
            this.is_knowledge = false;
            this.is_agents = false;
            this.is_document_agent = false;
            this.searchWebEnabled = false;
            this.knowledgeEnabled = true;
            this.knowledge_id = '';
            this.current_thread_id = '';
            this.portalDetails = [];
            this.clearAgent();
            await this.getKnowledgeList();
            await this.getKnowledgeListPrivate();
            await this.defaultColorKnowledgeList();
            // await this.getKnowledgeFolderTree();
            this.selectedKnowledgeLibs = this.knowledgeList.concat(this.KnowledgeListPrivate);
        },
        async getThread(type,data){
            this.targetQustion_Obj = {};
            this.drawer = false;
            if(type == 'insert'){
                this.set_main_view()
                this.is_new_insert = true;
            }else if(type == 'list'){
                if(!this.generating){
                    this.set_main_view();
                    this.loading = true;
                    this.is_user_setting = false;
                    this.is_new_insert = false;
                    this.is_knowledges = false;
                    this.is_knowledge = false;
                    this.is_agents = false;
                    await this.getKnowledgeList();
                    await this.getKnowledgeListPrivate();
                    this.defaultColorKnowledgeList();
                    const [{ id }] = data;
                    this.current_thread_id = id;
                    this.currentThread = data[0];
                    let qs_thread_id = {
                        thread_id: id,
                    }
                    await UpGPTPortalDataServices.getQuestion(qs_thread_id).then(response=>{
                        let data = response.data
                        data.forEach(item => {
                            item.related_image = item.related_image.flat();
                            item.tabs = this.getTabsBySourceType(item.ui_diaplay_source_type);
                            item.tabs_current = "tab-1";
                            if(item.feedback == "Helpful"){
                                item.thumb_up = true;
                                item.thumb_down = false;
                            }else if(item.feedback == "Unhelpful"){
                                item.thumb_up = false;
                                item.thumb_down = true;
                            }else{
                                item.thumb_up = false;
                                item.thumb_down = false;
                            }
                            if (Array.isArray(item.knowledges)) {
                                item.knowledges = item.knowledges.map(({ knowledge_detial_set, ...rest }) => rest);
                            }
                            this.searchWebEnabled=item.use_web_search;
                            this.knowledgeEnabled=item.use_knowledge_lib;
                            this.selectedKnowledgeLibs=item.knowledges;
                            // if(item.related.length <= 0) {
                            //     item.content = i18n.t('PORTAL.ERROR_3');
                            //     console.log('item.related.length', i18n.t('PORTAL.ERROR_3'))
                            // }
                        });
                        this.portalDetails = data
                        console.log('get data', this.portalDetails) // Thread_data檢查用
                    }).catch(response => {
                        if(response == 'Error: Request failed with status code 400' ||response == 'Error: Request failed with status code 500'){
                            let msg = i18n.t('PORTAL.ERROR_1');
                            this.showErrorDialog(msg);
                        }
                        this.searchWebEnabled=false;
                        this.knowledgeEnabled=true;
                        // this.showErrorDialog(response);
                    }).finally(()=>{
                        this.loading = false;
                    })
                }
            }
            else if(type == 'follow_question'){
                this.currentThread = data[0];
            }
            else if(type == 'agent'){
                this.set_main_view();
                this.is_agents = true;
            }
            else if(type == 'setting'){
                this.set_main_view();
                this.is_user_setting = true;
            }
            else if(type == 'knowledges'){
                this.set_main_view();
                this.is_knowledges = true;
            }
            else if(type == 'document_agent_template'){
                // this.set_main_view();
                // this.is_new_insert = true;
                this.documnet_agent_template_dialog = true;
            }
            else if(type == 'document_agent_detail'){
                this.set_main_view();
                this.is_document_agent = true;
                this.doc_agent_id = data.id;
                this.doc_agent_data = data;
            }

        },
        async getKnowledge(data){
            this.set_main_view();
            this.knowledge_id = data; // Set knowledge_id after set_main_view clears it
            this.is_knowledge = true; // Then set is_knowledge to true
        },
        async toKnowledges(){
          this.set_main_view();
          this.is_knowledges = true;
        },
        onEmitPD_Remove_Chunk(used_chunks){
            this.drawer = false;
            this.upsertQuestionData(this.targetQustion_Obj, undefined, true, used_chunks);
        },
        async deleteThreadAgentItem(data, mode){
            this.delMode = mode;
            this.toDeleteData = data;
            // dialog
            let delfilename = data.content;
            // this.messageDialog = true;
            this.deleteAgentDialog = true;
            this.deleteTargetName = delfilename;
        },
        cleanChunkPattern(chunkText){
            let removes = [
                '":"',
                ',"',
                '"}"',
                '","final_answer',
                ',"final_answer":"',
                'final_answer":"',
                'final_answer',
                'final',
                '_answer',
                '_answer":"**',
                '_answer":"**',
                'reason',
                '{"reasoning_th',
                '_th',
                'ing',
                'ink',
                '_step',
                'inking',
                '"related',
                'related'
            ]
            for(let s of removes){
                chunkText = chunkText.split(s).join('');
            }
            return chunkText;
        },
        async upsertQuestionData(data, index, chunk_mode=false, used_chunks=[]){
            const seq = this.beginGenerate();
            try {
            this.searchWebEnabled=data.use_web_search;
            this.knowledgeEnabled=data.use_knowledge_lib;
            data.knowledges.forEach(item=>{
                delete item.color;
            })
            this.selectedKnowledgeLibs = data.knowledges;
            // 有index代表Related Question否則是Ask follow Question,Change knowledge, Remove reference, Rewrite
            let upsertdata;
            if(Number.isFinite(index)){
                upsertdata = {
                    "thread_id":this.current_thread_id,
                    "question_id": '',
                    "question":data.related[index],
                    "knowledges":data.knowledges,
                    "general_instructions":data.general_instructions,
                    "attach_document":data.attach_document,
                    "use_web_search":data.use_web_search,
                    "use_knowledge_lib":data.use_knowledge_lib
                }
            }else{
                upsertdata = {
                    "thread_id":this.current_thread_id,
                    "question_id": data.question_id ? data.question_id :'',
                    "question":data.question_title,
                    "knowledges":data.knowledges,
                    "general_instructions":data.general_instructions,
                    "attach_document":data.attach_document,
                    "use_web_search":data.use_web_search,
                    "use_knowledge_lib":data.use_knowledge_lib
                }
            }
            if(chunk_mode){
                upsertdata.use_chunk_mode = chunk_mode;
                upsertdata.used_chunks = used_chunks;
            }
            let current_question_id = upsertdata.question_id;
            let editIndex = this.portalDetails.findIndex(item => item.question_id == current_question_id);

            // ========================= Scroll down =========================
            if(data.question_id && index == undefined){
                this.portalDetails[editIndex].content = ''
            }else{
                // 新增，沒有question_id 代表Ask follow Question，Related question模式
                this.$nextTick(() => {
                    setTimeout(() => {
                        const scrollContainer = document.querySelector('.portal-container');
                        if (scrollContainer) {
                            scrollContainer.scrollTo({
                            top: scrollContainer.scrollHeight+100,
                            behavior: 'smooth'
                            });
                        }
                    }, 1000);
                    // scroll again
                    const scrollContainer = document.querySelector('.portal-container');
                    scrollContainer.scrollTo({
                        top: scrollContainer.scrollHeight,
                        behavior: 'smooth'
                    });
                })
            }

            let chunk = {
                type: '',
                upsert_type: 'insert',
                question_id: upsertdata.question_id,
                question_title: upsertdata.question,
                question_on: new Date(),
                knowledges: upsertdata.knowledges,
                content: '',
                references: [],
                related_image: [],
                related: [],
                tabs:[{
                    id: 1,
                    key: 'Answer',
                    name: i18n.t('AGENT_STEP.ANSWER')
                }],
                tabs_current: "tab-1",
                step_flow: [],
                step_current: [],
                isSkeleton: true,
                generating: true,
                reasoning_thinking: "",
                function_calling: "",
                use_web_search: data.use_web_search,
                use_knowledge_lib: data.use_knowledge_lib
            };
            // 如果是新增，先 push 初始 chunk 到 portalDetails，並記住它的位置
            if(editIndex == -1 ){
                this.portalDetails.push(chunk);
                editIndex = this.portalDetails.length - 1;
            }
            else
            {
                this.$set(this.portalDetails,editIndex,chunk)
            }
            let jsonArray = [];
            let formData = new FormData();
            formData.append("thread_id", upsertdata['thread_id']);
            formData.append("question_id", upsertdata['question_id']);
            formData.append("question", upsertdata['question']);
            formData.append("knowledges", JSON.stringify(upsertdata['knowledges']));
            formData.append("general_instructions", upsertdata['general_instructions']);
            formData.append("use_web_search", upsertdata['use_web_search']);
            formData.append("use_knowledge_lib", upsertdata['use_knowledge_lib']);
            if(upsertdata.use_chunk_mode) {
                formData.append("use_chunk_mode", upsertdata['use_chunk_mode']);
                formData.append("used_chunks", JSON.stringify(upsertdata['used_chunks']));
            }
            if (upsertdata.attach_document && upsertdata.attach_document.length > 0) {
                upsertdata.attach_document.forEach(file => {
                    if(this.isFileType(file)){
                        formData.append("attach_document_files", file);
                    }else{
                        jsonArray.push(file);
                    }
                    formData.append("attach_document_json", JSON.stringify(jsonArray))
                })
            }
            // ========================= Streaming =========================
            let PUBLIC_URL = process.env.VUE_APP_API_BASE_URL;
            let BASE_URL = PUBLIC_URL + '/tenant';
            const { resp: stream_res, refreshFailed } = await fetchWithAuthRetry(`${BASE_URL}/${window.localStorage.getItem('tenant')}/api/upgpt_portal/thread/${upsertdata.thread_id}/`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('access_token')}`
                },
                body: formData
            });
            if (refreshFailed) {
                this.showErrorDialog(i18n.t('PORTAL.ERROR_4'));
                // let tenant = window.localStorage.getItem('tenant');
                // // if token refresh fails, logout the user to avoid potential security risks.
                // logoutUser();
                // if (tenant != null || tenant != '')
                //   window.location.href = `/login?tenant=${tenant}`;
                // else
                //   window.location.href = '/login';
            }
            // 處理接到的值
            let reader = stream_res.body.getReader();
            let decoder = new TextDecoder('utf-8');
            // 將接到的資料依序顯示
            let finish = false;
            let detect_area = "";
            let text_buffer = "";
            let start_collect_thinking = false;
            let start_collect_answer = false;
            const MARKER_REGEX = /reasoning_step"?\s*:/; // { 和開頭 " 可能被 pid/tid 邏輯丟棄
            const MARKER_FINALANS_REGEX = /","final_answer":"/;
            const stopState = { sid: null, question_id: '' };
            for await (let chunkText of streamChunks(reader, decoder)) {
                if (this.isAbandoned(seq)) {
                    this.handleStoppedChunk(seq, chunkText, stopState);
                    continue;
                    }
                // console.log('text',chunkText) // Streaming檢查用
                if (chunkText.startsWith('{"pid":')) {
                    try {
                        const obj = JSON.parse(chunkText);
                        if ("pid" in obj && "tid" in obj && "offset" in obj) {
                            // eslint-disable-next-line no-console
                            console.log('[STREAM] streamingId set ──►', obj);
                            this.streamingId = obj;
                        }
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.warn('[STREAM] JSON.parse failed for pid unit:', chunkText, e);
                    }
                    continue;
                }
                if(chunkText.includes('<QUESTION_ID>')){
                    let match = chunkText.match(/<QUESTION_ID>(.*?)<QUESTION_ID>/);
                    if(match && match[1]){
                        current_question_id = match[1];
                        chunk.question_id = match[1];
                        // console.log('current_question_id',current_question_id) // Streaming檢查用
                    }
                    chunk.reasoning_thinking = "";
                    chunk.type = 'final';
                    chunk.isSkeleton = false;
                }
                // 只有在 chunk.type 不是 final 時才處理 text_buffer 的內容
                if (chunk.type !== 'final') {
                    this.showStop = true;
                    detect_area += chunkText;
                    // 符合[Tool Call] 2種狀況1.一開始就call function.2.thinking後call function.
                    if(chunkText.includes('[Tool Call]')){
                        chunkText = chunkText.replace('[Tool Call]', '取得工具搜尋');
                        chunk.function_calling += '\n' + chunkText;
                    }
                    // 符合reasoning_thinking
                    if(detect_area.match(MARKER_REGEX)){
                        // console.log('------------------------抓到reasoning-----------------------------')
                        chunk.function_calling = "";
                        start_collect_thinking = true;
                        detect_area = "";
                    }
                    // 符合final_answer
                    if(detect_area.match(MARKER_FINALANS_REGEX)){
                        // 從 detect_area 取出 marker 後的真實內容，避免 chunk 邊界切斷造成 JSON key 殘留
                        const _fm = '","final_answer":"';
                        const _fpos = detect_area.indexOf(_fm);
                        chunkText = _fpos >= 0 ? detect_area.slice(_fpos + _fm.length) : '';
                        detect_area = "";
                        chunk.function_calling = "";
                        start_collect_thinking = false;
                        start_collect_answer = true;
                    }
                    // 開始蒐集reasoning文字
                    if(start_collect_thinking){
                        this.showGenerateAnsSkeleton = false;
                        chunkText = this.cleanChunkPattern(chunkText);
                        chunk.reasoning_thinking  += chunkText;
                        // start_collect_thinking = false;
                    }
                    // 開始蒐集FINALANSWER文字
                    if(start_collect_answer) {
                        if(chunkText.includes('取得工具搜尋')){
                            chunk.function_calling += '\n' + chunkText;
                        }
                        else{
                            if(chunkText.includes('related')){
                                detect_area = "";
                                chunk.content = "";
                                chunk.reasoning_thinking = "";
                                start_collect_thinking = false;
                                start_collect_answer = false;
                            }
                            chunkText = this.cleanChunkPattern(chunkText);
                            text_buffer += chunkText;
                            chunk.content = text_buffer;
                        }

                    }
                    // console.log('text_buffer',text_buffer) // Streaming檢查用
                    if(text_buffer.includes('<FINAL>')){
                        text_buffer = text_buffer.replace('<FINAL>', '');
                    }

                }
                // 如果為 final，設定內容並結束
                if(chunk['type'] == 'final'){
                    text_buffer = text_buffer.replace(/<QUESTION_ID>.*?<QUESTION_ID>/g, '').trim();
                    chunk.content = text_buffer;
                    finish = true; // 結束迴圈標記
                    // Retrieve the question_id to call the getQuestion API
                    let questionDetailData = await this.questionDetailData(chunk.question_id);
                    chunk = questionDetailData ? questionDetailData : chunk;
                    chunk.tabs_current = 'tab-1';
                    // if (response_relateds.data.length <= 0) {
                    //     chunk.content = i18n.t('PORTAL.ERROR_3');
                    // }
                    this.$set(this.portalDetails, editIndex, chunk);
                    await this.getQuestionKnowledge(current_question_id);
                    await this.$refs.menuBarPortal.updateCurrentThread(this.current_thread_id);
                    this.generating = false;
                    chunk.generating = false;
                    this.showStop = false;
                }
                if (finish) break;
            }
            if (this.isAbandoned(seq)) {
                await this.finishStoppedStream(seq, stopState, false);
                return;
            }
            let toGo = 'question-' + editIndex;
            if(editIndex >= 0){
                window.location.hash = `#${toGo}`
            }
            this.targetQustion_Obj = {};
            } finally {
                if (seq === this.genSeq) {
                    if (this.generating) {
                        console.warn('[STREAM] upsertQuestionData 未正常結束(後端中斷/連線關閉)，強制重置狀態');
                    }
                    this.generating = false;
                    this.showStop = false;
                    this.loading = false;
                }
            }
        },
        async defaultColorKnowledgeList() {
            this.allKnowledgeColor = this.knowledgeList.map((item, index) => {
                item['color'] = knowledge_color_group[index]?.color || 'aliceBlue';
                return{
                    id: item.id,
                    name: item.name,
                    color:item.color
                }
            });
            this.allKnowledgeColor_private = this.KnowledgeListPrivate.map((item,index) =>{
                item['color'] = knowledge_color_group[index]?.color || 'aliceBlue';
                return{
                    id: item.id,
                    name: item.name,
                    color:item.color,
                }
            });
            this.allKnowledgeColor = this.allKnowledgeColor.concat(this.allKnowledgeColor_private)
        },
        async getKnowledgeList() {
            await KnowledgeLibraryService.portal_list().then((response) => {
                this.knowledgeList = response.data.portal_knowledge.map(({ knowledge_detial_set, ...rest }) => rest)
                this.folderTreeOptions =  response.data.portal_knowledge_folder
            })
        },
        async getKnowledgeListPrivate(){
            await KnowledgeLibraryService.list_private(true).then((response)=> this.KnowledgeListPrivate = response.data.filter(el =>el.active === true).map(({ knowledge_detial_set, ...rest }) => rest))
        },
        checkCanView(nodes) {
            if (!Array.isArray(nodes)) return [];
            return nodes.flatMap(node => {
                const filteredChildren = node.children ? this.checkCanView(node.children) : [];
                const canViewSelf = node?.perm?.can_view === true;
                if (node.type === "library") {
                    return filteredChildren;
                }
                if (canViewSelf || filteredChildren.length > 0) {
                    return [{
                        ...node,
                        children: filteredChildren
                    }];
                }
                return [];
            });
        },
        getColorFromKnowledgeName(knowledge_name){
            let color_data = this.allKnowledgeColor.find(item=>item.name == knowledge_name);
            return color_data ? color_data.color : 'aliceBlue';
        },
        getWebIcon(url){
            const u = new URL(url);
            let iconpath = u.origin + "/favicon.ico";
            require("@/assets/images/agent_icon/award.png")
            return iconpath;
        },
        onWebIconImgError(e) {
            e.target.src = require("@/assets/images/search_web.svg")
        },
        toggleThumbUp(detail){
            let data = {
                "question_id": detail.question_id,
                "feedback": 'Helpful'
            }
            let itemIndex = this.portalDetails.findIndex(item=>item.question_id == detail.question_id);
            if (this.portalDetails[itemIndex].thumb_up) {
                this.$set(this.portalDetails[itemIndex], 'thumb_up', false);
            } else {
                this.$set(this.portalDetails[itemIndex], 'thumb_up', true);
                this.$set(this.portalDetails[itemIndex], 'thumb_down', false);
            }
            UpGPTPortalDataServices.updateFeedBack(data);
        },
        toggleThumbDown(detail){
            let data = {
                "question_id": detail.question_id,
                "feedback": 'Unhelpful'
            }
            let itemIndex = this.portalDetails.findIndex(item=>item.question_id == detail.question_id);
            if (this.portalDetails[itemIndex].thumb_down) {
                this.$set(this.portalDetails[itemIndex], 'thumb_down', false);
            } else {
                this.$set(this.portalDetails[itemIndex], 'thumb_up', false);
                this.$set(this.portalDetails[itemIndex], 'thumb_down', true);
            }
            UpGPTPortalDataServices.updateFeedBack(data);
        },
        async openDrawer(questiond_id, context_id, all_references, qustion_obj){
            this.targetQustion_Obj = JSON.parse(JSON.stringify(qustion_obj));
            let clonedReferences = JSON.parse(JSON.stringify(all_references));
            this.allReferences = clonedReferences;
            this.selectedQuestionid = questiond_id
            if(context_id == 'ALL'){
                this.selectedReference = clonedReferences;
                this.selectedMobileTagType = 'Reference';
            }else{
                let targetReference = '';
                for(let item of this.portalDetails){
                    if (item.question_id == questiond_id){
                         targetReference = item.references.find(reference=> reference.context_id == context_id)
                         if (targetReference) break;
                    }
                }
                if (targetReference.content === "" && targetReference.display_type === "TEXT") {
                    await UpGPTPortalDataServices.getReferencecontent(questiond_id,context_id).then((response)=>{
                        let data = JSON.parse(JSON.stringify(response.data))
                        targetReference.content = data.reference_content
                        this.selectedReference = targetReference
                        this.drawer = true;
                        this.selectedReference.iscopy = true;
                    }).catch(() => {
                          if (targetReference) {
                            targetReference.content = `#### ${this.$t('PORTAL.MISS_CONTENT_TITLE')} \n ${this.$t('PORTAL.MISS_CONTENT_DETAIL')}`;
                            this.selectedReference = targetReference;
                            this.selectedReference.iscopy = false;
                          }
                    })
                }else{
                    this.selectedReference = targetReference
                }
            }
            // Agent hide drawer remove references btn
            this.showRemoveBtn = this.targetQustion_Obj.ui_diaplay_source_type === 'agent' ? false : true;
            if(!this.drawer){
                this.drawer = true;
            }
        },
        openRelatedImagesDrawer(){
            this.relatedImagesDrawer = true;
        },
        onEmitPortalDrawer(){
            this.drawer = false;
            this.targetQustion_Obj = {};
            this.selectedMobileTagType = 'Answer';
        },
        onEmitPortalRelatedImages(){
            this.relatedImagesDrawer = false;
            this.selectedMobileTagType = 'Answer';
        },
        getAnsSupStr(str){
            str = String(str).replace(/-$/, "");
            str = String(str).replaceAll(/\[([A-Z0-9]{1,5})\]/g,'<sup>$1</sup>')
            .replaceAll(/【([A-Z0-9]{1,5})】/g,'<sup>$1</sup>')
            .replaceAll(/\[(\d+)\]/g,'<sup>$1</sup>')
            .replaceAll(/\\n\\n-|\\n-|\\n|\\n\\n/g, '<br/>');
            return str
        },
        copyAnswer(text){
            let contentEl = document.querySelector('.answer');
            text = text.replaceAll(/\[([^\]]+)\]/g,'').replace(/\*\*(.*?)\*\*/g, '$1')
            let hasTable = contentEl.querySelectorAll('table').length > 0;
            if(hasTable){
                let range = document.createRange();
                range.selectNodeContents(contentEl);
                let selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                document.execCommand('copy');
                selection.removeAllRanges();
            } else if (navigator.clipboard) {
                navigator.clipboard.writeText(text);
            } else {
                const el = document.createElement('textarea');
                el.value = text;
                el.style.cssText = 'position:fixed;opacity:0';
                document.body.appendChild(el);
                el.focus();
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            }
            parent.postMessage({isUpday:true,from: "CopyText",data:text}, "*")
            if(this.copied == false){
                this.copied = true;
                setTimeout(()=>{
                    this.copied = false;
                },1000)
            }
        },
        setAnswerLinkTarget() {
            const answerLinks = this.$el.querySelectorAll('.answer-line-height a')
            answerLinks.forEach(link => {
                link.setAttribute('target', '_blank')
                link.setAttribute('rel', 'noopener noreferrer')
            })
        },
        bindingEvent(){
            this.$nextTick(()=>{
                const supTags = document.querySelectorAll('sup');
                const strongTags = document.querySelectorAll('strong');
                supTags.forEach((tag)=>{
                    tag.addEventListener('mouseover',this.mouseOver);
                    tag.addEventListener('mouseleave', this.hideContentCard);
                    tag.addEventListener('click',this.onClickShowReference);
                    tag.setAttribute('data-bound', 'true');
                })
                strongTags.forEach((tag)=>{
                    tag.addEventListener('click',this.onClickFollowAction);
                })
            })
        },
        observeQuestion(entries){
            entries.forEach(entry=>{
                const id = entry.target.id;
                const match = id.match(/question-(\d+)/);
                if(!match) return;

                const index = parseInt(match[1]);

                if (entry.isIntersecting) {
                    // viewport
                    if(this.currentPortalDetailIndex !== index){
                        this.currentPortalDetailIndex = index;
                        this.mobileQuestion = this.portalDetails[index];
                        if(this.mobileQuestion.ui_diaplay_source_type == 'agent') this.mobileRelated = 'No Related'
                        this.mobileRelatedImages = this.portalDetails[index].related_image;
                        this.mobileReference = this.portalDetails[index].references;
                    }
                }
            })
        },
        handleObservation(){
            this.$nextTick(() => {
                const questionEls = document.querySelectorAll('[id^="question-"]');
                if (!questionEls.length) {
                    console.warn('Not find element');
                    return;
                }
                if (this.observer) {
                    this.observer.disconnect();
                }
                this.observer = new IntersectionObserver(this.observeQuestion, {
                    root: null,
                    threshold: 0.3,
                });
                questionEls.forEach(el=>this.observer.observe(el));
            })
        },
        mouseOver(e){
            if (this.hoverTimeout) {
                clearTimeout(this.hoverTimeout);
            }
            let mouseX = e.clientX;
            let mouseY = e.clientY;
            let innerContent = e.target.innerText;
            let supEl = e.target;
            let questionEl = supEl.closest('[data-question-id]');
            let questionId;
            if(questionEl){
                questionId = questionEl.getAttribute('data-question-id');
            }
            this.hoverTimeout = setTimeout(()=>{
                this.showContentCard(innerContent,questionId,mouseX,mouseY);
            },500)
        },
        showContentCard(keyword,id,mouseX,mouseY){
            if(!this.generating && this.$vuetify.breakpoint.lgAndUp){
                let question = this.portalDetails.find(item=>item.question_id==id);
                if(question){
                    this.contentDialog = true;
                    this.$nextTick(() => {
                        let dialogEl = document.querySelector('.v-dialog__content');
                        if (dialogEl) {
                            dialogEl.style.display = 'unset';
                            dialogEl.style.top = `${mouseY}px`;
                            dialogEl.style.left = `${mouseX-140}px`;
                        }
                        let reference = question.references.find(item => item.context_id == keyword);
                        this.currentReference = reference;
                        this.contentMessage = this.currentReference.cut_content;
                        this.dialogKey++;
                    })
                }
            }
        },
        hideContentCard(){
            if (this.hoverTimeout) {
                clearTimeout(this.hoverTimeout);
                this.hoverTimeout = null;
            }
            this.contentDialog = false;
        },
        async onClickFollowAction(e){
            if(!this.generating){
                const seq = this.beginGenerate();
                try {

                let innerContent = e.target.innerText;
                let strongEl = e.target;
                let questionEl = strongEl.closest('[data-question-id]');
                let questionId;
                if(questionEl){
                    questionId = questionEl.getAttribute('data-question-id')
                    const targetQuestion = this.portalDetails.find(item => item.question_id == questionId);
                    this.selectedKnowledgeLibs = targetQuestion?.knowledges ?? [];
                    this.searchWebEnabled = targetQuestion?.use_web_search ?? false;
                    this.knowledgeEnabled = targetQuestion?.use_knowledge_lib ?? true;
                    this.is_new_insert = false;
                    let upsertdata = {
                        "thread_id":this.current_thread_id,
                        "question_id": '',
                        "question": innerContent,
                        "knowledges":this.selectedKnowledgeLibs,
                        "use_web_search":this.searchWebEnabled,
                        "use_knowledge_lib":this.knowledgeEnabled,
                    }
                    // ========================= Scroll down 將畫面移至最新的位置  =========================
                    this.$nextTick(() => {
                        setTimeout(() => {
                            const scrollContainer = document.querySelector('.portal-container');
                            if (scrollContainer) {
                                scrollContainer.scrollTo({
                                top: scrollContainer.scrollHeight,
                                behavior: 'smooth'
                                });
                            }
                        }, 1000);
                            // again
                            const scrollContainer = document.querySelector('.portal-container');
                            scrollContainer.scrollTo({
                                top: scrollContainer.scrollHeight,
                                behavior: 'smooth'
                            });
                    })

                    let chunk = {
                        type: '',
                        upsert_type: 'insert',
                        question_id: '',
                        question_title: innerContent,
                        question_on: new Date(),
                        knowledges: this.selectedKnowledgeLibs,
                        content: '',
                        references: [],
                        related_image: [],
                        related: [],
                        tabs:[{
                            id: 1,
                            key: 'Answer',
                            name: i18n.t('AGENT_STEP.ANSWER')
                        }],
                        tabs_current: "tab-1",
                        step_flow: [],
                        step_current: [],
                        isSkeleton: true,
                        generating: true,
                        reasoning_thinking: "",
                        function_calling: "",
                        use_web_search: this.searchWebEnabled,
                        use_knowledge_lib: this.knowledgeEnabled
                    };
                    this.portalDetails.push(chunk);
                    let chunkIndex = this.portalDetails.length - 1;

                    // ========================= Streaming =========================
                    // Call Streaming API
                    let PUBLIC_URL = process.env.VUE_APP_API_BASE_URL;
                    let BASE_URL = PUBLIC_URL + '/tenant';
                    const { resp: stream_res, refreshFailed } = await fetchWithAuthRetry(`${BASE_URL}/${window.localStorage.getItem('tenant')}/api/upgpt_portal/thread/${upsertdata.thread_id}/`,
                    {
                        method: 'POST',
                        headers: {
                            Authorization: `Bearer ${window.localStorage.getItem('access_token')}`,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(upsertdata)
                    });
                    if (refreshFailed) {
                        this.showErrorDialog(i18n.t('PORTAL.ERROR_4'));
                        // let tenant = window.localStorage.getItem('tenant');
                        // // if token refresh fails, logout the user to avoid potential security risks.
                        // logoutUser();
                        // if (tenant != null || tenant != '')
                        //   window.location.href = `/login?tenant=${tenant}`;
                        // else
                        //   window.location.href = '/login';
                    }
                    // 處理接到的值
                    let reader = stream_res.body.getReader();
                    let decoder = new TextDecoder('utf-8');
                    // 將接到的資料依序顯示
                    let finish = false;
                    let current_question_id = '';
                    let detect_area = "";
                    let text_buffer = "";
                    let start_collect_thinking = false;
                    let start_collect_answer = false;
                    const MARKER_REGEX = /reasoning_step"?\s*:/; // { 和開頭 " 可能被 pid/tid 邏輯丟棄
                    const MARKER_FINALANS_REGEX = /","final_answer":"/;
                    const stopState = { sid: null, question_id: '' };
                    for await (let chunkText of streamChunks(reader, decoder)) {
                        if (this.isAbandoned(seq)) {
                            this.handleStoppedChunk(seq, chunkText, stopState);
                            continue;
                        }
                        // console.log('text',chunkText)
                        if (chunkText.startsWith('{"pid":')) {
                            try {
                                const obj = JSON.parse(chunkText);
                                if ("pid" in obj && "tid" in obj && "offset" in obj) {
                                    this.streamingId = obj;
                                }
                            } catch (e) { /* ignore */ }
                            continue;
                        }
                        if(chunkText.includes('<QUESTION_ID>')){
                            let match = chunkText.match(/<QUESTION_ID>(.*?)<QUESTION_ID>/);
                            if(match && match[1]){
                                current_question_id = match[1];
                                chunk.question_id = match[1];
                            }
                            chunk.reasoning_thinking = "";
                            chunk.type = 'final';
                            chunk.isSkeleton = false;
                        }
                        // 只有在 chunk.type 不是 final 時才處理 text_buffer 的內容
                        if (chunk.type !== 'final') {
                            this.showStop = true;
                            detect_area += chunkText;
                            if(chunkText.includes('[Tool Call]')){
                                chunkText = chunkText.replace('[Tool Call]', '取得工具搜尋');
                                chunk.function_calling += '\n' + chunkText;
                            }
                            if(detect_area.match(MARKER_REGEX)){
                                chunk.function_calling = "";
                                start_collect_thinking = true;
                                detect_area = "";
                            }
                            if(detect_area.match(MARKER_FINALANS_REGEX)){
                                // 從 detect_area 取出 marker 後的真實內容，避免 chunk 邊界切斷造成 JSON key 殘留
                                const _fm = '","final_answer":"';
                                const _fpos = detect_area.indexOf(_fm);
                                chunkText = _fpos >= 0 ? detect_area.slice(_fpos + _fm.length) : '';
                                detect_area = "";
                                chunk.function_calling = "";
                                start_collect_thinking = false;
                                start_collect_answer = true;
                            }
                            // 開始蒐集reasoning文字
                            if(start_collect_thinking){
                                this.showGenerateAnsSkeleton = false;
                                chunkText = this.cleanChunkPattern(chunkText);
                                chunk.reasoning_thinking  += chunkText;
                            }
                            // 開始蒐集answer文字
                            if(start_collect_answer) {
                                if(chunkText.includes('取得工具搜尋')){
                                    chunk.function_calling += '\n' + chunkText;
                                }else{
                                    if(chunkText.includes('related')){
                                        detect_area = "";
                                        chunk.content = "";
                                        chunk.reasoning_thinking = "";
                                        start_collect_thinking = false;
                                        start_collect_answer = false;
                                    }
                                    chunkText = this.cleanChunkPattern(chunkText);
                                    text_buffer += chunkText;
                                    chunk.content = text_buffer;
                                }
                            }
                            // console.log('text_buffer',text_buffer) // Streaming檢查用
                            if(text_buffer.includes('<FINAL>')){
                                text_buffer = text_buffer.replace('<FINAL>', '');
                            }

                        }
                        // 如果為 final，設定內容並結束
                        if(chunk['type'] == 'final'){
                            text_buffer = text_buffer.replace(/<QUESTION_ID>.*?<QUESTION_ID>/g, '').trim();
                            this.portalDetails[chunkIndex].content = text_buffer;
                            // console.log('final',text_buffer) // Streaming檢查用
                            let questionDetailData = await this.questionDetailData(chunk.question_id);
                            chunk = questionDetailData ? questionDetailData : chunk;
                            chunk.tabs_current = 'tab-1';
                            finish = true; // 結束迴圈標記
                            this.$set(this.portalDetails, chunkIndex, chunk);
                            await this.getQuestionKnowledge(current_question_id);
                            // await this.getKnowledgeList();
                            this.generating = false;
                            chunk.generating = false;
                            this.showStop = false;
                        }
                        if (finish) break;
                    }
                    if (this.isAbandoned(seq)) {
                        await this.finishStoppedStream(seq, stopState, false);
                        return;
                    }
                    let lastItem = this.portalDetails.length-1;
                    let toGo = 'question-' + lastItem;
                    if(lastItem >= 0){
                        window.location.hash = `#${toGo}`
                    }
                }
                } finally {
                    if (seq === this.genSeq) {
                        if (this.generating) {
                            console.warn('[STREAM] onClickFollowAction 未正常結束(後端中斷/連線關閉)，強制重置狀態');
                        }
                        this.generating = false;
                        this.showStop = false;
                        this.loading = false;
                    }
                }
            }
        },
        onClickShowReference(e){
            let innerContent = e.target.innerText;
            let supEl = e.target;
            let questionEl = supEl.closest('[data-question-id]');
            let questionId = questionEl.getAttribute('data-question-id');
            let question = this.portalDetails.find(item=>item.question_id==questionId);
            if(question){
                let reference = question.references.find(item => item.context_id == innerContent);
                this.openDrawer(question.question_id, reference.context_id, question.references, question);
            }
        },
        viewLessRelatedImage(){
            this.showAllImage = !this.showAllImage;
        },
        filteredImages(data){
            let relatedImage = data.related_image;
            return this.showAllImage ? relatedImage.slice(0,3) : relatedImage;
        },
        showAllKnowledge(knowledge){
            if(this.knowledgeListShowAll>this.knowledgeDefaultLength){
                this.knowledgeListShowAll = this.knowledgeDefaultLength;
            }else{
                this.knowledgeListShowAll = knowledge.length;
            }
        },
        showErrorDialog(message) {
            this.errorDialog = true;
            this.errorMessage = message;
        },
        onEmitErrorDialog() {
            this.errorDialog = false;
        },
        handleImageError(e){
            e.target.src = errorbackImage;
            this.errorImg = true;
        },
        async getQuestionKnowledge(id){
            // let targetIndex = this.portalDetails.findIndex(item => item.question_id == id);
            let targetKnowledge = this.portalDetails.find(item=>item.question_id==id);
            let combineList = this.knowledgeList.concat(targetKnowledge.knowledges);

            const privateIds = new Set(this.KnowledgeListPrivate.map(item => item.id));
            const seen = new Set();
            const filteredList = combineList.filter(item => {
                if (seen.has(item.id) || privateIds.has(item.id)) return false;
                seen.add(item.id);
                return true;
            });
            this.questionKnowledgeList = filteredList;
        },
        correctJsonFormat(json_text){
            return `[${json_text.replace(/}\{/g, '},{')}]`;
        },
        openWindowDisplayImage(img){
                // 存到 localStorage
                const storageKey = 'doc_image_url_temp';
                window.localStorage.setItem(storageKey, img.doc_image_url);
                // 開新視窗，不帶 query
                const routeUrl = this.$router.resolve({ path: '/image_url' });
                window.open(routeUrl.href, '_blank');
        },
        setBodyStyle(){
            document.body.style.backgroundColor = this.portal_background;
            if (this.$vuetify.breakpoint.mdAndDown) document.body.style.overflowY = 'hidden';
        },
        goToTarget(type){
            let targetEl;
            if(type == 'Related'){
                targetEl = this.$refs[`questionItem-related-${this.currentPortalDetailIndex}`][0];
            }else if(type == 'Answer') {
                targetEl = this.$refs[`questionItem-${this.currentPortalDetailIndex}`][0];
            }
            if(targetEl){
                targetEl.scrollIntoView({behavior: 'smooth'});
            }
        },
        clickMobileTag(type){
            this.selectedMobileTagType = type;

            switch(type){
                case 'Reference':
                    this.openDrawer(this.mobileQuestion.question_id, 'ALL', this.mobileReference, this.mobileQuestion);
                    break;
                case 'RelatedImages':
                    this.openRelatedImagesDrawer();
                    break;
                case 'Related':
                    this.goToTarget(type);
                    this.drawer=false;
                    this.relatedImagesDrawer=false;
                    break;
                case 'Answer':
                    this.goToTarget(type);
                    this.drawer=false;
                    this.relatedImagesDrawer=false;
                    break;
                default:
                    this.drawer=false;
                    this.relatedImagesDrawer=false;
            }
        },
        ///UserSetting
        validateForm(){
                this.valid = this.$refs.form.validate();
                if(this.valid)
                    return true;
                else
                    return false;
            },
            getUserDetail(){
                PersonalSettingService.getCurrentUserDetail()
                .then(response =>
                {
                    this.userData = response.data[0];
                    this.userID = this.userData.usersetting.user_id;
                    this.userImageId = this.userData.usersetting.id;
                    this.change_password = this.userData.usersetting.change_password
                    this.check_reset_password()
                    if(response.data[0].usersetting.photo != null)
                    {
                        this.isUserPhoto = true;
                        this.userPhoto = response.data[0].usersetting.photo;
                    }
                    if(response.data[0].usersetting.default_value != null)
                    {
                        if(response.data[0].usersetting.default_value.default_process != undefined){
                            this.opptyProcess = response.data[0].usersetting.default_value.default_process.opportunity;
                            this.caseProcess = response.data[0].usersetting.default_value.default_process.case;
                        }
                    }
                    this.userLanguage = response.data[0].usersetting.language;
                    this.userLocation = response.data[0].usersetting.location ;
                    this.board_contact_sync = response.data[0].usersetting.board_contact_sync;
                    if(response.data[0].usersetting.web_push  != null)
                    {
                        if("alert" in response.data[0].usersetting.web_push)
                        {
                            this.allow_web_push = response.data[0].usersetting.web_push['alert'];
                        }
                        if("follow" in response.data[0].usersetting.web_push)
                        {
                            this.allow_follow = response.data[0].usersetting.web_push['follow'];
                        }
                        if("mention" in response.data[0].usersetting.web_push)
                        {
                            this.allow_mention = response.data[0].usersetting.web_push['mention'];
                        }
                        if("reply" in response.data[0].usersetting.web_push)
                        {
                            this.allow_reply = response.data[0].usersetting.web_push['reply'];
                        }
                        if("emoji" in response.data[0].usersetting.web_push)
                        {
                            this.allow_emoji = response.data[0].usersetting.web_push['emoji'];
                        }
                    }
                })
                .catch((response) => {
                    this.showErrorDialog(response);
                });
            },
            checkLength(){
                const regex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,30}/);
                this.passwordCheck = regex.test(this.password.new)
            },
            checkConfirm(){
                if(this.passwordCheck===true&&this.password.confirm===this.password.new)
                {
                    this.confirmPasswordCheck = true
                }
                else{
                    this.confirmPasswordCheck = false
                    }
            },
            async onPasswordChange() {
                if (!this.password.current)
                {
                    this.errorDialog = true;
                    this.errorMessage = i18n.t('PASSWORDANDLOGIN.ERROR_3');
                    return false;
                }
                if (!this.password.new || !this.password.confirm)
                {
                    this.errorDialog = true;
                    this.errorMessage = i18n.t('PASSWORDANDLOGIN.ERROR_4');
                    return false;
                }
                if (this.password.new != this.password.confirm)
                {
                    this.errorDialog = true;
                    this.errorMessage = i18n.t('PASSWORDANDLOGIN.ERROR_7');
                    return false;
                }
                if(this.passwordCheck!=true&&this.confirmPasswordCheck!=true)
                {
                    this.errorDialog = true;
                    this.errorMessage = i18n.t('PASSWORDANDLOGIN.ERROR_5');
                    return false;
                }
                var data = { 'old_password': this.password.current, 'new_password': this.password.new };
                this.loading = true;

                await AccountDataService.changePassword(data)
                .then(() => {
                    this.loading = false;
                    this.successDialog = true;
                })
                .catch(() => {
                    this.loading = false;
                    this.errorDialog = true;
                    this.errorMessage = i18n.t('PASSWORDANDLOGIN.ERROR_6');
                });
                this.password = { current: '', new: '', confirm: '' };
                this.haveChange = true
            },
            showSuccessDialog() {
                this.successDialog = true;
            },
            onEmitSuccessDialog() {
                this.successDialog = false;
                window.location.reload()
            },
            async onEmitMessageDialog(val) {
                // UpSide 登出 - 第三步 => 呼叫 upsideLogout 方法來實作登出
                if(val){
                    if(this.isUpsideLogout){
                        this.upsideLogout();
                    }
                    this.isUpsideLogout = false;
                    this.messageDialog = false;
                }
                if(val && this.delMode == 'delThread'){
                    let thread_id = this.toDeleteData.id;
                    await UpGPTPortalDataServices.deleteThread(thread_id);
                    await this.$refs.menuBarPortal.getThreadListData();
                    await this.getThread("insert");
                    await this.$refs.menuBarPortal.set_selected_thread(null);
                }
                else if(val && this.delMode == 'delUserAgent'){
                    let doc_agent_id = this.toDeleteData.id;
                    await UpGPTPortalDataServices.deleteDocumentAgent(doc_agent_id);
                    await this.$refs.menuBarPortal.getUserDocumentAgentMenuList();
                    await this.getThread("insert");
                }
                else if(val && this.delMode == 'delSimpleUserAgnet'){
                    await UpGPTPortalDataServices.deleteUserAgent(this.del_agent_detail.id);
                    await this.getAgentListData();
                }
                this.messageDialog = false;
            },
            async getUserDefaultProcess(item){
                let userDefaultValue = {
                    'default_filter' : {
                        'Contact': null,
                        'Opportunity': null,
                        'Organization': null,
                        'Case': null,
                    },
                    "default_process": {
                        "case": this.caseProcess,
                        "opportunity": this.opptyProcess
                    }
                }

                if(item.usersetting.default_value == null){
                    item.usersetting.default_value = userDefaultValue;
                }
                else if(item.usersetting.default_value != null){
                    item.usersetting.default_value.default_process = userDefaultValue.default_process;
                }
            },
            async onSave(item)
            {
                if(this.validateForm() && this.userData.id == this.userID)
                {
                    item.usersetting.language = this.userLanguage;
                    item.usersetting.location = this.userLocation;
                    item.usersetting.board_contact_sync = this.board_contact_sync;
                    item.usersetting.web_push = {
                            'alert':this.allow_web_push,
                            'follow':this.allow_follow,
                            'mention':this.allow_mention,
                            'reply':this.allow_reply,
                            'emoji':this.allow_emoji,
                        };
                    await this.getUserDefaultProcess(item);
                    await PersonalSettingService.updateDetail(this.userID,item)
                    .then(() => {
                        const USER = 'user';
                        let userJson = window.localStorage.getItem(USER);
                        let user = JSON.parse(userJson);
                        user.first_name = this.userData.first_name;
                        user.last_name = this.userData.last_name;
                        user.default_value = item.usersetting.default_value;
                        window.localStorage.setItem(USER, JSON.stringify(user));
                        window.localStorage.setItem('language', this.userLanguage);
                        window.localStorage.setItem('location', this.userLocation);
                        let newUserName = {'first_name':this.userData.first_name,'last_name':this.userData.last_name};
                        this.menuBarName(newUserName);
                        this.showSuccessDialog();
                        this.valid = false;
                    });
                }
            },
            changephoto(){
                this.$refs.uploader.$refs.input.click()
            },
            menuBarPhoto(data){
                this.newPicUrl = data
                passData.$emit("menuBarPic", this.newPicUrl);
            },
            menuBarName(data){
                this.newName = data
                passData.$emit("menuBarName", this.newName);
            },
            async uploadimage(event){
                if (event != null) {
                    // file type
                    let n = event.type.indexOf("image");
                    if (n == -1) {
                        this.showErrorDialog(i18n.t('PERSONALSETTING.ERROR'));
                    } else {
                    // photo size
                        if (event.size > 5242880) {
                            this.showErrorDialog(i18n.t('PERSONALSETTING.ERROR_2'));
                        } else {
                            await PersonalSettingService.image(this.userImageId, this.userImage)
                            .then(response => {
                                this.isUserPhoto = true
                                this.userPhoto = response.data.photo;
                                const USER = 'user';
                                let userJson = window.localStorage.getItem(USER);
                                let user = JSON.parse(userJson);
                                user.pic = this.userPhoto
                                window.localStorage.setItem(USER, JSON.stringify(user));
                                this.menuBarPhoto(this.userPhoto)
                            });
                        }
                    }
                }
            },
            customFilter (item, queryText){
                const textOne = item.name.toLowerCase()
                const textTwo = item.en_name.toLowerCase()
                const searchText = queryText.toLowerCase()

                return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
            },
            async check_reset_password(){
                let isADFS = false;
                await PreferenceService.isADFSLogin().then(response =>{
                    isADFS = response.data === "ADFS";
                });
                if ((this.change_password === true) && (!isADFS)) {
                    this.is_user_setting = true;
                    this.is_new_insert = false;
                    this.current_thread_id = '';
                    this.portalDetails = [];
                    this.selectedKnowledgeLibs = [];
                }
                else{
                    this.is_user_setting = false;
                    this.is_new_insert = true;
                }
            },
            getselectedKnowledgeList(data,index){
                this.portalDetails[index].knowledges = data;
            },
            triggerUpsert(data,detail){
                detail.use_web_search = data.use_web_search;
                detail.use_knowledge_lib = data.use_knowledge_lib;
                this.upsertQuestionData(detail)
            },
            changeWebSearchSetting(data,detail){
                detail.use_web_search = data;
                let editIndex = this.portalDetails.findIndex(item => item.question_id == detail.question_id);
                this.$set(this.portalDetails,editIndex,detail);
            },
            changeUseKnowledgeSetting(data,detail){
                detail.use_knowledge_lib = data;
                let editIndex = this.portalDetails.findIndex(item => item.question_id == detail.question_id);
                this.$set(this.portalDetails,editIndex,detail);
            },
            logoutSuccess(){
                this.$emit('logoutSuccess');
            },
            // Agent
            async toggleAgentChips(filter){
                let agentGroup = ['simple_agent', 'advanced_agent'];
                let privacyGroup = ['private', 'public'];
                if(agentGroup.includes(filter.key)){
                    this.agentfilterStyleList.forEach(f => {
                        if(agentGroup.includes(f.key)){
                            // f.active = (f.key == filter.key) ? !filter.active : false;
                            if(f.key == filter.key){
                                filter.active = true;
                            }else{
                                f.active = false;
                            }
                        }
                    })
                    // 更新 agent_style
                    let selected = this.agentfilterStyleList.find(f => agentGroup.includes(f.key) && f.active);
                    this.agent_style = selected ? (selected.key == "simple_agent" ? "simple" : "advance") : null;
                }
                if(privacyGroup.includes(filter.key)){
                    this.agentfilterPolicyList.forEach(f => {
                        if(privacyGroup.includes(f.key)){
                            f.active = (f.key == filter.key) ? !filter.active : false;
                        }
                    })
                    // 更新 agent_definition_mode
                    let selected = this.agentfilterPolicyList.find(f =>privacyGroup.includes(f.key) && f.active);
                    this.agent_definition_mode = selected ? (selected.key == "public" ? "public" : "private") : null;
                }
                await this.getAgentListData();
            },
            async getAgentListData() {
                this.loading = true;
                await UpGPTPortalDataServices.getUserAgentList(this.agent_style, this.agent_definition_mode).then((response)=>{
                    let data = response.data;
                    data.forEach(item => {
                        item.knowledges = item.linked_useragents_and_knowledge_set.map(item=> {return item.knowledge_lib});
                    })
                    this.AgentsList = data;
                    this.loading = false;
                })
            },
            addAgent(){
                this.showAddAgentDrawer = true;
                this.showEditAgentDrawer = false;
                this.showEditAdvanceAgentDrawer = false;
            },
            onEmitAgentDetailAndRunDrawer(data){
                this.showEditAdvanceAgentDrawer = false;
                this.agent_detail = {};
                this.is_new_insert = false;
                this.runAgentProcess(data)
            },
            onEmitCloseAgentDrawer(type, isUpdated, updatedData){
                if(type == "addSimpleAgent"){
                    this.showAddAgentDrawer = false;
                }else if(type == "editSimpleAgent"){
                    this.agent_detail = isUpdated ? updatedData : {};
                    this.showEditAgentDrawer = false;
                    this.clearAgent();
                }else if(type == "editAdvanceAgent"){
                    this.agent_detail = isUpdated ? updatedData : {};
                    this.showEditAdvanceAgentDrawer = false;
                }
            },
            async runAgentProcess(agentUserInputData){
                // api
                this.loading = true;
                const seq = this.beginGenerate();
                try {
                this.searchWebEnabled = false;
                this.knowledgeEnabled = true;
                if(agentUserInputData){
                    // deal with no val
                    let thread_title = agentUserInputData.agent_name
                    agentUserInputData.agent_config.forEach(step => {
                        if(step.step_type == 'user_input'){
                            step.config_param.forEach(input => {
                                if(input.data_type == 'document_upload' || input.data_type == 'image_upload'){
                                    thread_title += ` | ${input.data.name}`
                                } else {
                                    thread_title += ` | ${input.data}`
                                }
                            })
                        }
                    })
                    this.generatingTitle = thread_title;
                    // if (thread_title.length > 30) {
                    //     thread_title = thread_title.slice(0, 30) + '...';
                    // }
                    let data_createThread = {"question": thread_title};
                    let response_createThread = await UpGPTPortalDataServices.createThread(data_createThread);
                    this.current_thread_id = response_createThread.data.thread_id;
                    let formData = new FormData();
                    formData.append('agent_id', agentUserInputData.agent_id);
                    formData.append('thread_id', this.current_thread_id);
                    formData.append('agent_config', JSON.stringify(agentUserInputData.agent_config));
                    formData.append('general_instruction', agentUserInputData.general_instruction);
                    formData.append('question', agentUserInputData.question);
                    formData.append('upload_image', agentUserInputData.upload_image);
                    agentUserInputData.agent_config[0].config_param.forEach((param) => {
                        if (param.data_type === 'document_upload' || param.data_type === 'image_upload') {
                            let key = `${param.system_name}`;
                            // 確認是FILE or dict
                            if (agentUserInputData[key] instanceof File) {
                                formData.append(key, agentUserInputData[key]);
                            } else if (typeof agentUserInputData == "object") {
                                formData.append(key, JSON.stringify(agentUserInputData[key]));
                            }
                        }
                    });
                    formData.append('Knowledge_libs', JSON.stringify(agentUserInputData.Knowledge_libs));
                    let PUBLIC_URL = process.env.VUE_APP_API_BASE_URL;
                    let BASE_URL = PUBLIC_URL + '/tenant';
                    const { resp: stream_res, refreshFailed } = await fetchWithAuthRetry(`${BASE_URL}/${window.localStorage.getItem('tenant')}/api/upgpt_agent/agent/${this.current_thread_id}/`,
                    {
                        method: 'POST',
                        headers: {
                            Authorization: `Bearer ${window.localStorage.getItem('access_token')}`
                        },
                        body: formData
                    });
                    if (refreshFailed) {
                        this.showErrorDialog(i18n.t('PORTAL.ERROR_4'));
                        // let tenant = window.localStorage.getItem('tenant');
                        // // if token refresh fails, logout the user to avoid potential security risks.
                        // logoutUser();
                        // if (tenant != null || tenant != '')
                        //   window.location.href = `/login?tenant=${tenant}`;
                        // else
                        //   window.location.href = '/login';
                    }
                    let reader = stream_res.body.getReader();
                    let decoder = new TextDecoder();

                    let finish = false;
                    let text_buffer = "";
                    let chunk = {
                        type: '',
                        upsert_type: 'insert',
                        question_id: '',
                        question_title: thread_title,
                        question_on: new Date(),
                        knowledges: [],
                        content: '',
                        references: [],
                        related_image: [],
                        related: [],
                        tabs:[
                            {
                                id: 2,
                                key: 'Step',
                                name: i18n.t('AGENT_STEP.STEP')
                            }
                        ],
                        tabs_current: "tab-2",
                        step_flow: [],
                        step_current: [],
                        isSkeleton: true,
                        generating: true,
                        use_web_search: false,
                        use_knowledge_lib: true
                    };
                    let stepCount = 0;
                    let lastArr = 0;
                    this.showGenerateAnsSkeleton = false;
                    await this.$refs.menuBarPortal.getThreadListData();
                    this.displayType = 'Agent';
                    if (!this.isAbandoned(seq)) {
                        this.portalDetails = [chunk];
                    }
                    const stopState = { sid: null, question_id: '' };
                    for await (let chunkText of streamFrames(reader, decoder)) {
                        if (this.isAbandoned(seq)) {
                            this.handleStoppedChunk(seq, chunkText, stopState);
                            continue;
                        }
                        this.loading = false;
                        let obj;
                        let pre_array = [];
                        pre_array.push(chunk);
                        this.portalDetails = pre_array;
                        let check_objs_exist = chunkText.split("data:").map(x => x.split("[[<<REPLACE>>]]")[0].trim()).filter(x => x.startsWith("{"));
                        if(check_objs_exist.length > 0){
                            // 判斷有物件回應
                            // console.log("JSON 字串切分組", check_objs_exist);
                            for (let obj_str of check_objs_exist){
                                // console.log("JSON 字串", obj_str);
                                obj = JSON.parse(obj_str);
                                // console.log("這是obj",obj);

                                if ("pid" in obj && "tid" in obj && "offset" in obj){
                                    // console.log("Streaming ID", obj);
                                    this.streamingId = obj;
                                    continue;
                                }

                                if (Array.isArray(obj.step_memory)) {
                                    obj.step_memory.forEach(item => {
                                        if ("skeleton" in item) {
                                            let new_step_memory = []
                                            chunk.isSkeleton = item.skeleton;
                                            if ("filename" in item && Array.isArray(item.filename)) {
                                                const files = item.filename.map(f => ({ filename: f }));
                                                new_step_memory.push(...files);
                                            }
                                            obj.step_memory = new_step_memory;
                                        }
                                    });
                                }
                                if(obj.step_type === 'end'){
                                    chunk.type = 'final';
                                }else{
                                    // 檢查並取得目前的流程到哪一步，為了比對，沒有開始時，會設定 unstart
                                    this.currentStepType = obj.step_type;
                                    let current_step_index, current_step;
                                    if (chunk.step_flow.length>0){
                                        current_step_index = chunk.step_flow.length -1;
                                        current_step = chunk.step_flow[current_step_index];
                                    }else{
                                        current_step = {"step_type":"unstart"};
                                    }
                                    // 先判斷是新增還是補充，因為Title要先傳
                                    if (obj.step_type === current_step['step_type']){
                                        current_step['step_memory'] = obj.step_memory;
                                    }else{
                                        chunk.step_flow.push(obj);
                                        chunk.step_current = [stepCount];
                                        stepCount++;
                                    }
                                    // 如果是 respond 要把 UI 轉到 tab-1
                                    if (obj.step_type === "respond"){
                                        text_buffer = "";
                                        chunk.content = text_buffer;
                                        chunk.tabs.unshift({
                                            id: 1,
                                            key: 'Answer',
                                            name: i18n.t('AGENT_STEP.ANSWER')
                                        })
                                        chunk.tabs_current = 'tab-1';
                                    }
                                }
                            }
                        }else{
                            // 判斷是文字回應
                            // Retrieve the question_id to call the getQuestion API
                            if(chunkText.includes('<QUESTION_ID>')){
                                let match_question_id = chunkText.match(/<QUESTION_ID>(.*?)<QUESTION_ID>/);
                                if(match_question_id && match_question_id[1]){
                                    let current_question_id = match_question_id[1];
                                    // console.log('current_question_id Streaming檢查用',current_question_id); // Streaming檢查用
                                    chunk.question_id = current_question_id;
                                }
                            }
                            if (chunk.type !== 'final') {
                                let word;
                                if(chunkText.includes('data:')){
                                    // console.log('一開始的 Streaming 文字', chunkText)
                                    chunkText = chunkText.replace(/data:/g, '');
                                    chunkText = chunkText.replace(/<QUESTION_ID>.*?<QUESTION_ID>/g, '').trim();
                                }
                                if(chunkText.includes('[[<<REPLACE>>]]')){
                                    chunkText = chunkText.replaceAll('[[<<REPLACE>>]]', '');
                                    chunkText = chunkText.replace(/\r?\n\r?\n/g, '');
                                    word = chunkText;
                                    // console.log('處理後的 Streaming 文字', word)
                                }
                                text_buffer += word;
                                lastArr = chunk.step_flow.length -1
                                chunk.step_flow[lastArr]['step_memory'] = text_buffer;
                                chunk.content = text_buffer;
                            }
                        }
                        // call getQuestionAPI
                        if(chunk.type == 'final'){
                            let questionDetailData = await this.questionDetailData(chunk.question_id);
                            chunk = questionDetailData ? questionDetailData : chunk;
                            chunk.tabs_current = 'tab-1';
                            finish = true; // 結束迴圈標記
                            this.portalDetails = [chunk];
                            chunk.isSkeleton = false;
                        }
                        if (finish) break;
                    }
                    if (this.isAbandoned(seq)) {
                        await this.finishStoppedStream(seq, stopState, true);
                        return;
                    }
                    this.generating = false;
                    chunk.generating = false;
                    this.showStop = false;
                }
                } finally {
                    if (seq === this.genSeq) {
                        if (this.generating) {
                            console.warn('[STREAM] runAgentProcess 未正常結束(後端中斷/連線關閉)，強制重置狀態');
                        }
                        this.generating = false;
                        this.showStop = false;
                        this.loading = false;
                    }
                }
            },
            async questionDetailData(question_id){
                try {
                    let response_thread_question = await UpGPTPortalDataServices.getreferenceQuestions(question_id);
                    let chunk = response_thread_question.data;
                    chunk.related_image =  chunk.related_image.flat();
                    chunk.tabs = await this.getTabsBySourceType(chunk.ui_diaplay_source_type);

                    return chunk;
                } catch (err) {
                    console.error('Error in questionDetailData:', err);
                    return null;
                }
            },
            getTabsBySourceType(ui_diaplay_source_type){
                if (ui_diaplay_source_type === 'agent') {
                    return [
                        {id: 1, key: 'Answer', name: i18n.t('AGENT_STEP.ANSWER') },
                        { id: 2, key: 'Step', name: i18n.t('AGENT_STEP.STEP') }
                    ]
                }
                return [
                    {id: 1, key: 'Answer', name: i18n.t('AGENT_STEP.ANSWER') }
                ];
            },
            getPortalFormatTime(data){
                if(!data) return '';
                const d = new Date(data);
                if(isNaN(d.getTime())) return '';
                const pad = n => String(n).padStart(2, '0');
                return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
            },
            async getUserAgentDetail(dataId){
                await UpGPTPortalDataServices.getUserAgentDetail(dataId).then(response => {
                    let data = response.data;
                    data.knowledges = data.linked_useragents_and_knowledge_set.map(item=> {return item.knowledge_lib});
                    data.folders = data.linked_useragents_and_knowledge_folder_set.map(item=> {return item.knowledge_folder});
                    this.agent_detail = data;
                }).catch((response) => {
                    this.showErrorDialog(response);
                });
            },
            async open_select_drawer(data){
                this.agent_detail.attach_document = [];
                await this.getUserAgentDetail(data.id);
                this.showEditAdvanceAgentDrawer = true;
                let user = JSON.parse(window.localStorage.getItem('user'));
                let file_data = {
                    agent_id: this.agent_detail.id,
                    tenant: window.localStorage.getItem('tenant'),
                    user_id: user["userid"],
                    mode: "private"
                };
                try{ 
                    let response = await UpGPTPortalDataServices.getAgentUploadedFiles(file_data);
                    let data = response.data;
                    if (data.document && Object.keys(data.document).length > 0) {
                        Object.keys(data.document).forEach(key => {
                            let details = data.document[key];
                            // 原本開drawer時會在前端組FILE，現在直接用dict
                            // if (details && details.length > 0) {
                            //     let firstchunk = details[0];
                            //     let blob;
                            //     blob = new Blob([details]);
                            //     let file = new File([blob], firstchunk.file_name);
                            //     Vue.set(this.file_attachments, key, file);
                            // }
                            Vue.set(this.file_attachments,key, details);
                        });
                    } else if (data.upload_status != "completed") {
                        this.showErrorDialog(i18n.t('AGENT_FILE_ATTACHMENT.STILL_RUN'));
                        this.childAddBtnLoading = true;
                        this.childEditMode = false;
                    } else {
                        this.file_attachments = [];
                    }

                    if (data.image && Object.keys(data.image).length > 0) {
                        // 要組成image b64放到image_attachments裡面
                    } else {
                        this.image_attachments = [];
                    }
                } catch(error) {
                    console.log(error);
                }
            },
            async onEmitEditAgentCardDetail(data){
                await this.getUserAgentDetail(data.id);
                if(this.agent_detail.agent_style == "simple"){
                    this.showEditAgentDrawer = true;
                    this.showAddAgentDrawer = false;
                    this.showEditAdvanceAgentDrawer = false;
                }else if(this.agent_detail.agent_style == "advance"){
                    this.showEditAdvanceAgentDrawer = true;
                    this.showEditAgentDrawer = false;
                    this.showAddAgentDrawer = false;
                }
            },
            onEmitDeleteAgentDetail(data){
                this.del_agent_detail = data;
                this.delMode = 'delSimpleUserAgnet';
                this.deleteAgentDialog = true;
                this.deleteTargetName = data.agent_name;
                this.$refs.threadInputRef.clearAgent();
            },
            onDeleteUserAgentCancel() {
                this.deleteAgentDialog = false;
                this.del_agent_detail = {};
            },
            async onDeleteUserAgentConfirm() {
                try {
                    if (this.delMode == 'delThread') {
                         let thread_id = this.toDeleteData.id;
                         await UpGPTPortalDataServices.deleteThread(thread_id);
                         await this.$refs.menuBarPortal.getThreadListData();
                         await this.getThread("insert");
                         await this.$refs.menuBarPortal.set_selected_thread(null);
                    } else if (this.delMode == 'delUserAgent') {
                         let doc_agent_id = this.toDeleteData.id;
                         await UpGPTPortalDataServices.deleteDocumentAgent(doc_agent_id);
                         await this.$refs.menuBarPortal.getUserDocumentAgentMenuList();
                         await this.getThread("insert");
                    } else {
                        await UpGPTPortalDataServices.deleteUserAgent(this.del_agent_detail.id);
                        await this.getAgentListData();
                    }
                    this.deleteAgentDialog = false;
                    this.del_agent_detail = {};
                    this.toDeleteData = {};
                    this.delMode = '';
                } catch (error) {
                    // 被分享者（非 owner）刪除 Instance 後端回 403，顯示友善的「沒有權限」訊息
                    if (error.response && error.response.status === 403) {
                        this.showErrorDialog(i18n.t('WORK_AGENT.NO_DELETE_PERMISSION'));
                    } else {
                        this.showErrorDialog(error.message || i18n.t('PORTAL.DELETE_FAILED'));
                    }
                }
            },
            async applyAgent(data) {
                try {
                    const { data: item } = await UpGPTPortalDataServices.getUserAgentDetail(data.id);

                    this.agent_to_userInput = JSON.parse(JSON.stringify(item));

                    const copy_knowledge = (item.linked_useragents_and_knowledge_set || [])
                        .map((x) => (x.knowledge_lib ? { ...x.knowledge_lib } : null))
                        .filter(Boolean)
                        .map(({ knowledge_detial_set, ...rest }) => rest);
                    this.selectedKnowledgeLibs = copy_knowledge;

                    await this.$nextTick();
                } catch (err) {
                    this.showErrorDialog(err);
                }
            },
            clearAgent(){
                this.agent_to_userInput={};
                this.currentThread={};
                this.selectedKnowledgeLibs = [...this.knowledgeList, ...this.KnowledgeListPrivate];
            },
            async editDeleteFile(file, filterFiles, agentdetail){
                if(file){
                    await UpGPTPortalDataServices.editDeleteFile(agentdetail.id, file);
                }
            },
            onEmitDocumentAgentTemplateDialog(data){
                if (data.blank) {
                    this.documnet_agent_template_dialog = false;
                    this.ai_generate_dialog = true;
                    return;
                }
                this.getThread("document_agent_detail", data);
                this.$refs.menuBarPortal.getUserDocumentAgentMenuList();
                this.documnet_agent_template_dialog = false;
            },
            onEmitCloseDocumentAgentTemplateDialog(){
                this.documnet_agent_template_dialog = false;
            },
            async onEmitAiGenerate(prompt) {
                // AI 生成 Work Agent 設定會呼叫 LLM，所以授權阻擋時也要擋下。
                // 這支後端端點不在 task 5／6 的伺服器端攔截範圍內，前端這一關是
                // 目前唯一的阻擋點。
                if (await this.$store.dispatch('refreshLicenseBlocking')) {
                    this.ai_generate_dialog = false;
                    return;
                }
                this.ai_generate_loading = true;
                this.ai_generate_error_type = null;
                try {
                    const response = await UpGPTPortalDataServices.aiGenerateDocumentAgent(prompt);
                    this.ai_generate_dialog = false;
                    this.getThread("document_agent_detail", response.data);
                    this.$refs.menuBarPortal.getUserDocumentAgentMenuList();
                } catch (error) {
                    const backendErrorType = error.response?.data?.error_type;
                    if (backendErrorType) {
                        const errorMap = {
                            llm_timeout: 'timeout',
                            llm_connection_error: 'service_error',
                            llm_invalid_response: 'invalid_format',
                            llm_failed: 'service_error',
                            create_failed: 'create_failed',
                        };
                        this.ai_generate_error_type = errorMap[backendErrorType] || 'service_error';
                    } else if (error.code === 'ECONNABORTED' || (error.message && error.message.includes('timeout'))) {
                        this.ai_generate_error_type = 'timeout';
                    } else {
                        this.ai_generate_error_type = 'service_error';
                    }
                } finally {
                    this.ai_generate_loading = false;
                }
            },
            async onEmitDirectCreate() {
                this.ai_generate_loading = true;
                this.ai_generate_error_type = null;
                try {
                    const response = await UpGPTPortalDataServices.directCreateDocumentAgent();
                    this.ai_generate_dialog = false;
                    this.getThread("document_agent_detail", response.data);
                    this.$refs.menuBarPortal.getUserDocumentAgentMenuList();
                } catch (error) {
                    this.ai_generate_error_type = 'create_failed';
                } finally {
                    this.ai_generate_loading = false;
                }
            },
            // extenson
            async loginMessage(e){
                if(e.data.from=="UpSide" && e.data.id=="UpSideLogin"){
                    this.upside_tenant = e.data.value.tenant;
                    if(e.data.type=="userData"){
                        window.removeEventListener('message', this.loginMessage, false);
                    }else if(e.data.type=="no_localStorage"){
                    // 
                        console.log("No local storage")
                    }
                }
            },
            ...mapActions([
                'logout',
            ]),
            // UpSide 傳入訊息處理
            async receiveMessage(e){
                // 確保 iframe 傳入者是 UpSide 才有動作
                if(e.data.from=="UpSide"){
                    // UpSide 登出 - 第二步 => 傳到 messageDialog 以確認是否登出
                    if(e.data.id=="UpSideLogout"){
                        this.isUpsideLogout = true;
                        this.messageDialog = true;
                        this.message = i18n.t('GENERAL.LOGOUT_MSG');
                    } 
                    if(e.data.type=="Change Mode"){
                        parent.postMessage({
                            isUpday:true,
                            from: "ScreenShot",
                            isloading:true
                        }, "*")

                        if(e.data.start){
                            this.screenshoot_loading = true;
                            this.screenShot();
                        }
                    }else if(e.data.type=="Change To Portal Landing"){
                        if(e.data.mode=="portal"){
                            await this.getThread("insert");
                        }
                    }else if(e.data.type=="Get_Query_String"){
                        await this.getAnalysisQueryString(e.data.data,e.data.error);
                    }else if(e.data.type=="Log_Out_UpSide_Final"){
                        // UpSide 登出 - 第九步 => 正式清除 Portal 的內容以登出
                        let tenant = window.localStorage.getItem('tenant');
                        let sso = window.localStorage.getItem('sso');
                        let isSSO = (sso === "true");
                        let isTSC = window.location.href.includes("ai.topco-global.com");
                        await this.logout().then(() => {
                            let redirectTo = '';
                            if (isSSO) {
                                if (this.isUpsideExtension) {
                                    console.log("從 CX 登出")
                                    this.upsideLogout();
                                }
                                redirectTo = (tenant != null && tenant !== '') ? `/sso-upgpt-login?tenant=${tenant}&next=%2Fupgpt_portal%2F` : '/sso-upgpt-login?next=%2Fupgpt_portal%2F';
                                if (isTSC) {
                                    redirectTo = (tenant != null && tenant !== '') ? `/sso-tsc-login?tenant=${tenant}&next=%2Fupgpt_portal%2F` : '/sso-tsc-login?next=%2Fupgpt_portal%2F';
                                }
                            } else {
                                console.log("JWT UpSide Portal 登出")
                                redirectTo = (tenant != null && tenant != '') ? `/upgpt-login?tenant=${tenant}&next=%2Fupgpt_portal%2F` : '/upgpt-login?next=%2Fupgpt_portal%2F';
                            }
                            this.logoutSuccess();
                            this.$router.push(redirectTo);
                        })
                    }
                }
            },
            async screenShot(){
                let query_string = JSON.parse(JSON.stringify(this.aisearch));
                await this.getApiDataAndCallApi("ScreenShot",query_string);
            },
            async getApiDataAndCallApi(from,query){
                if(!this.api_data.api_key && !this.api_data.tenant){
                    await PreferenceService.getApiKey().then((response)=>{
                        if(response.data == ""){
                            return;
                        }
                        this.api_data.api_key = response.data;
                        this.api_data.tenant = this.upside_tenant;
                    })
                }
                parent.postMessage({isUpday:true,from: from,key: this.api_data,data:query}, "*")
            },
            async getAnalysisQueryString(data,error){
                if(error){
                    if(data){
                        this.screenshoot_loading = false;
                        this.showErrorDialog(i18n.t('UPMEETING.BACKEND_ERROR'));
                    }
                    return;
                }
                this.screenshoot_loading = false;
                await this.upsideAIAnswer(data);
            },
            // UpSide 登出 - 第四步 => 傳值給 UpSide 進行 App 端登出
            upsideLogout(){
                console.log("傳值給 UpSide 進行 App 端登出")
                this.upside_tenant = '';
                this.screenshoot_loading = false;
                parent.postMessage({
                    isUpday: true,
                    from: "UpSide_Logout",
                    value: "byebye"
                }, "*")
            },
            onEmitDocumentDetail(){
                this.$refs.menuBarPortal.getUserDocumentAgentMenuList();
            },
            redirectAgentId(){
                const redirectAgentId = this.$route.query.user_agent;
                if (redirectAgentId) {
                    this.doc_agent_id = redirectAgentId;
                    this.set_main_view();
                    this.is_document_agent = true;

                    this.$router.replace({
                        path: this.$route.path,
                        query: {}
                    });
                }
            },
        async if_private_knowledge(){
            await KnowledgeLibraryService.list_private(true).then(response => {
                this.numner_knowledge_private = response.data.length;
            });
            await PreferenceService.getPrivateKnowledge().then((response) => {
                this.private_knowledge_from_pref = response.data;
            });
            if(this.private_knowledge_from_pref === 1){
                this.show_private_knowledge = true;
                this.show_private_knowledge_add_btn = true;
            }
            else if(this.numner_knowledge_private>0) {
                this.show_private_knowledge = true;
                this.show_private_knowledge_add_btn = false;
            }
            else{
                this.show_private_knowledge = false;
                this.show_private_knowledge_add_btn = false;
            }
        },
        
    },
    computed: {
        endPointDrawerWidth(){
            const { xs, sm, md, lg, xl } = this.$vuetify.breakpoint
            if (xs) return '100%'
            if (sm) return '50%'
            if (md) return '45%'
            if (lg) return '29%'
            if (xl) return '29%'
            return '29%';
        },
        visibleTags(){
            return this.mobileTags.filter(tag=>{
                if(tag.type == 'RelatedImages' || tag.type == 'Reference'){
                    let content = this[`mobile${tag.type}`];
                    return Array.isArray(content) && content.length > 0;
                }
                if(tag.type == 'Related'){
                    return this[`mobile${tag.type}`] != 'No Related';
                }
                return true;
            })
        },
        ...mapState([
            'isUpsideExtension',
        ]),
        // selectedKnowledgeLibsKey(){
        //     const ids = (this.selectedKnowledgeLibs || []).map(x => x.id || JSON.stringify(x))
        //     return ids.join('|') + ':' + ids.length
        // }
    },
    watch:{
        loading(val){
            if (val == false){
                this.handleObservation();
            }
        },
        generating(val){
            if (val == false){ 
                this.handleObservation();
            }
            this.selectedMobileTagType = 'Answer';
        },
        "password.new":function(e){
            const regex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,30}/);
            this.passwordCheck = regex.test(e)
            if(this.haveChange)
            {
               this.passwordCheck = null
            }
        },
        "password.confirm":function(e){
            if(this.passwordCheck===true&&e===this.password.new){
                this.confirmPasswordCheck = true
            }else
            {
                this.confirmPasswordCheck = false
            }
            if(this.haveChange)
            {
               this.confirmPasswordCheck = null
               this.haveChange = false
            }
        },
    }
};
</script>

<style scoped lang="css">
    .container-fluid {
        width: 100%;
    }
    .pb-d-21 {
        padding-bottom: 84px !important;
    }
    .ellipsis-single{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 150px;
        display: inline-block;
    }
    .portal-time {
        font-size: 12px;
        color: #999;
    }
</style>